// tslint:disable
/**
 * Users API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddAgentUserDto
 */
export interface AddAgentUserDto {
    /**
     * 
     * @type {string}
     * @memberof AddAgentUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAgentUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAgentUserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAgentUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddAgentUserDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddAgentUserDto
     */
    isAhl?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddAgentUserDto
     */
    isNewYork?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AddAgentUserDto
     */
    roleIds?: Array<number> | null;
    /**
     * 
     * @type {RecruiterCode}
     * @memberof AddAgentUserDto
     */
    recruiterCode?: RecruiterCode | null;
}
/**
 * 
 * @export
 * @interface AddBeneficiaryUserDto
 */
export interface AddBeneficiaryUserDto {
    /**
     * 
     * @type {string}
     * @memberof AddBeneficiaryUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBeneficiaryUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBeneficiaryUserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBeneficiaryUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBeneficiaryUserDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AddBeneficiaryUserDto
     */
    roleIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AddBusinessOperationsSupportDto
 */
export interface AddBusinessOperationsSupportDto {
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOperationsSupportDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOperationsSupportDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOperationsSupportDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOperationsSupportDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOperationsSupportDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AddBusinessOperationsSupportDto
     */
    roleIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AddEnrollTrackUserRequestDto
 */
export interface AddEnrollTrackUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddEnrollTrackUserRequestDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddEnrollTrackUserRequestDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddEnrollTrackUserRequestDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddEnrollTrackUserRequestDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddEnrollTrackUserRequestDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AddEnrollTrackUserRequestDto
     */
    roleIds?: Array<number> | null;
    /**
     * 
     * @type {Position}
     * @memberof AddEnrollTrackUserRequestDto
     */
    position?: Position | null;
}
/**
 * 
 * @export
 * @interface AddExclusiveAgentRequest
 */
export interface AddExclusiveAgentRequest {
    /**
     * 
     * @type {string}
     * @memberof AddExclusiveAgentRequest
     */
    createByUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddExclusiveAgentRequest
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddExclusiveAgentRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddExclusiveAgentRequest
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddExclusiveAgentRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddExclusiveAgentRequest
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {ExclusivityStatus}
     * @memberof AddExclusiveAgentRequest
     */
    exclusivityStatus?: ExclusivityStatus | null;
    /**
     * 
     * @type {Array<AgencyAssociationAddRequest>}
     * @memberof AddExclusiveAgentRequest
     */
    agencyAssociations?: Array<AgencyAssociationAddRequest> | null;
}
/**
 * 
 * @export
 * @interface AddIndependentAgentRequestDto
 */
export interface AddIndependentAgentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddIndependentAgentRequestDto
     */
    key?: string | null;
    /**
     * 
     * @type {IdentityUser}
     * @memberof AddIndependentAgentRequestDto
     */
    identityUser?: IdentityUser | null;
}
/**
 * 
 * @export
 * @interface AddPreregisteredAgentCommand
 */
export interface AddPreregisteredAgentCommand {
    /**
     * 
     * @type {string}
     * @memberof AddPreregisteredAgentCommand
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddPreregisteredAgentCommand
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddPreregisteredAgentCommand
     */
    email?: string | null;
    /**
     * 
     * @type {Array<AgencyAssociationAddRequest>}
     * @memberof AddPreregisteredAgentCommand
     */
    agencyAssociations?: Array<AgencyAssociationAddRequest> | null;
}
/**
 * 
 * @export
 * @interface AgencyAssociationAddRequest
 */
export interface AgencyAssociationAddRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationAddRequest
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationAddRequest
     */
    encryptedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationAddRequest
     */
    email?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencyAssociationAddRequest
     */
    additionalScopes?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgencyAssociationAddRequest
     */
    roleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<AgentNumberRequest>}
     * @memberof AgencyAssociationAddRequest
     */
    agentNumbers?: Array<AgentNumberRequest> | null;
}
/**
 * 
 * @export
 * @interface AgencyAssociationDto
 */
export interface AgencyAssociationDto {
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationDto
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationDto
     */
    maskedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationDto
     */
    encryptedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationDto
     */
    email?: string | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof AgencyAssociationDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<AgentNumberDto>}
     * @memberof AgencyAssociationDto
     */
    agentNumbers?: Array<AgentNumberDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencyAssociationDto
     */
    scopes?: Array<string> | null;
    /**
     * 
     * @type {Array<AgentRole>}
     * @memberof AgencyAssociationDto
     */
    roles?: Array<AgentRole> | null;
}
/**
 * 
 * @export
 * @interface AgencyAssociationEditRequest
 */
export interface AgencyAssociationEditRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationEditRequest
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationEditRequest
     */
    encryptedIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationEditRequest
     */
    email?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgencyAssociationEditRequest
     */
    additionalScopes?: Array<string> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgencyAssociationEditRequest
     */
    roleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<AgentNumberRequest>}
     * @memberof AgencyAssociationEditRequest
     */
    agentNumbers?: Array<AgentNumberRequest> | null;
}
/**
 * 
 * @export
 * @interface AgencyAssociationRequestDto
 */
export interface AgencyAssociationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AgencyAssociationRequestDto
     */
    email?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof AgencyAssociationRequestDto
     */
    roleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<AgentNumberRequest>}
     * @memberof AgencyAssociationRequestDto
     */
    agentNumbers?: Array<AgentNumberRequest> | null;
}
/**
 * 
 * @export
 * @interface AgentNumberDto
 */
export interface AgentNumberDto {
    /**
     * 
     * @type {string}
     * @memberof AgentNumberDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNumberDto
     */
    recruiterCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentNumberDto
     */
    isNewYork?: boolean;
}
/**
 * 
 * @export
 * @interface AgentNumberRequest
 */
export interface AgentNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof AgentNumberRequest
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentNumberRequest
     */
    isNewYork?: boolean;
}
/**
 * 
 * @export
 * @interface AgentNumberStatus
 */
export interface AgentNumberStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface AgentNumberUpdateRequestDto
 */
export interface AgentNumberUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AgentNumberUpdateRequestDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNumberUpdateRequestDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNumberUpdateRequestDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNumberUpdateRequestDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNumberUpdateRequestDto
     */
    maskedLastFourTaxId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentNumberUpdateRequestDto
     */
    agentNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentNumberUpdateRequestDto
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AgentNumberUpdateRequestDto
     */
    isComplete?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AgentNumberUpdateRequestDto
     */
    createDate?: Date;
}
/**
 * 
 * @export
 * @interface AgentNumberWithStatusDto
 */
export interface AgentNumberWithStatusDto {
    /**
     * 
     * @type {string}
     * @memberof AgentNumberWithStatusDto
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentNumberWithStatusDto
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {AgentNumberStatus}
     * @memberof AgentNumberWithStatusDto
     */
    status?: AgentNumberStatus | null;
}
/**
 * 
 * @export
 * @interface AgentRole
 */
export interface AgentRole extends RoleBase {
}
/**
 * 
 * @export
 * @interface AgentUserDetailDto
 */
export interface AgentUserDetailDto {
    /**
     * 
     * @type {string}
     * @memberof AgentUserDetailDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentUserDetailDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentUserDetailDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentUserDetailDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentUserDetailDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentUserDetailDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {Array<FieldSalesLeaderDto>}
     * @memberof AgentUserDetailDto
     */
    fieldSalesLeaders?: Array<FieldSalesLeaderDto> | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof AgentUserDetailDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<AgencyAssociationDto>}
     * @memberof AgentUserDetailDto
     */
    agencyAssociations?: Array<AgencyAssociationDto> | null;
}
/**
 * 
 * @export
 * @interface AgentUserTypeDto
 */
export interface AgentUserTypeDto {
    /**
     * 
     * @type {boolean}
     * @memberof AgentUserTypeDto
     */
    isNewYork?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentUserTypeDto
     */
    isAhl?: boolean | null;
    /**
     * 
     * @type {UserStatus}
     * @memberof AgentUserTypeDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<FieldSalesLeaderDto>}
     * @memberof AgentUserTypeDto
     */
    fieldSalesLeaders?: Array<FieldSalesLeaderDto> | null;
    /**
     * 
     * @type {Array<AgentRole>}
     * @memberof AgentUserTypeDto
     */
    roles?: Array<AgentRole> | null;
    /**
     * 
     * @type {RecruiterCode}
     * @memberof AgentUserTypeDto
     */
    recruiterCode?: RecruiterCode | null;
    /**
     * 
     * @type {Array<AgencyAssociationDto>}
     * @memberof AgentUserTypeDto
     */
    agencyAssociations?: Array<AgencyAssociationDto> | null;
}
/**
 * 
 * @export
 * @interface ApplicationEntryRole
 */
export interface ApplicationEntryRole extends RoleBase {
}
/**
 * 
 * @export
 * @interface ApplicationEntryUserTypeDto
 */
export interface ApplicationEntryUserTypeDto {
    /**
     * 
     * @type {UserStatus}
     * @memberof ApplicationEntryUserTypeDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<ApplicationEntryRole>}
     * @memberof ApplicationEntryUserTypeDto
     */
    roles?: Array<ApplicationEntryRole> | null;
}
/**
 * 
 * @export
 * @interface BeneficiaryRole
 */
export interface BeneficiaryRole extends RoleBase {
}
/**
 * 
 * @export
 * @interface BeneficiaryUserTypeDto
 */
export interface BeneficiaryUserTypeDto {
    /**
     * 
     * @type {UserStatus}
     * @memberof BeneficiaryUserTypeDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<BeneficiaryRole>}
     * @memberof BeneficiaryUserTypeDto
     */
    roles?: Array<BeneficiaryRole> | null;
}
/**
 * 
 * @export
 * @interface BusinessOperationsSupportRole
 */
export interface BusinessOperationsSupportRole extends RoleBase {
}
/**
 * 
 * @export
 * @interface BusinessOperationsSupportUserTypeDto
 */
export interface BusinessOperationsSupportUserTypeDto {
    /**
     * 
     * @type {UserStatus}
     * @memberof BusinessOperationsSupportUserTypeDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<BusinessOperationsSupportRole>}
     * @memberof BusinessOperationsSupportUserTypeDto
     */
    roles?: Array<BusinessOperationsSupportRole> | null;
}
/**
 * 
 * @export
 * @interface EditAgentRequestDto
 */
export interface EditAgentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof EditAgentRequestDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentRequestDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentRequestDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentRequestDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentRequestDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {Array<AgencyAssociationEditRequest>}
     * @memberof EditAgentRequestDto
     */
    agencyAssociations?: Array<AgencyAssociationEditRequest> | null;
}
/**
 * 
 * @export
 * @interface EditAgentUserDto
 */
export interface EditAgentUserDto {
    /**
     * 
     * @type {string}
     * @memberof EditAgentUserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentUserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditAgentUserDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditAgentUserDto
     */
    isAhl?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditAgentUserDto
     */
    isNewYork?: boolean | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof EditAgentUserDto
     */
    roleIds?: Array<number> | null;
    /**
     * 
     * @type {RecruiterCode}
     * @memberof EditAgentUserDto
     */
    recruiterCode?: RecruiterCode | null;
}
/**
 * 
 * @export
 * @interface EmailUpdateRequestDto
 */
export interface EmailUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof EmailUpdateRequestDto
     */
    email?: string | null;
}
/**
 * 
 * @export
 * @interface EnrollTrackRole
 */
export interface EnrollTrackRole extends RoleBase {
}
/**
 * 
 * @export
 * @interface EnrollTrackUserTypeDto
 */
export interface EnrollTrackUserTypeDto {
    /**
     * 
     * @type {UserStatus}
     * @memberof EnrollTrackUserTypeDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<EnrollTrackRole>}
     * @memberof EnrollTrackUserTypeDto
     */
    roles?: Array<EnrollTrackRole> | null;
    /**
     * 
     * @type {Position}
     * @memberof EnrollTrackUserTypeDto
     */
    position?: Position | null;
}
/**
 * 
 * @export
 * @interface Enumeration
 */
export interface Enumeration {
    /**
     * 
     * @type {string}
     * @memberof Enumeration
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Enumeration
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface ExclusivityStatus
 */
export interface ExclusivityStatus extends Enumeration {
}
/**
 * 
 * @export
 * @interface FieldSalesLeaderDto
 */
export interface FieldSalesLeaderDto {
    /**
     * 
     * @type {string}
     * @memberof FieldSalesLeaderDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldSalesLeaderDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldSalesLeaderDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldSalesLeaderDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {RecruiterCode}
     * @memberof FieldSalesLeaderDto
     */
    recruiterCode?: RecruiterCode | null;
}
/**
 * 
 * @export
 * @interface IHeaderDictionary
 */
export interface IHeaderDictionary {
    /**
     * 
     * @type {Array<string>}
     * @memberof IHeaderDictionary
     */
    Item?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IHeaderDictionary
     */
    ContentLength?: number | null;
}
/**
 * 
 * @export
 * @interface IdentityQuestion
 */
export interface IdentityQuestion {
    /**
     * 
     * @type {string}
     * @memberof IdentityQuestion
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityQuestion
     */
    question?: string | null;
}
/**
 * 
 * @export
 * @interface IdentityUser
 */
export interface IdentityUser {
    /**
     * 
     * @type {string}
     * @memberof IdentityUser
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUser
     */
    password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUser
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUser
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUser
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityUser
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {Array<SecurityQuestion>}
     * @memberof IdentityUser
     */
    securityQuestions?: Array<SecurityQuestion> | null;
}
/**
 * 
 * @export
 * @interface IndependentAgentProfileDto
 */
export interface IndependentAgentProfileDto {
    /**
     * 
     * @type {string}
     * @memberof IndependentAgentProfileDto
     */
    userId?: string | null;
    /**
     * 
     * @type {Array<SecurityQuestionWithoutAnswer>}
     * @memberof IndependentAgentProfileDto
     */
    securityQuestions?: Array<SecurityQuestionWithoutAnswer> | null;
}
/**
 * 
 * @export
 * @interface LegalDocumentClaim
 */
export interface LegalDocumentClaim {
    /**
     * 
     * @type {string}
     * @memberof LegalDocumentClaim
     */
    id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LegalDocumentClaim
     */
    versionNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LegalDocumentClaim
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {LegalDocumentType}
     * @memberof LegalDocumentClaim
     */
    legalDocumentType?: LegalDocumentType | null;
}
/**
 * 
 * @export
 * @interface LegalDocumentDto
 */
export interface LegalDocumentDto {
    /**
     * 
     * @type {string}
     * @memberof LegalDocumentDto
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof LegalDocumentDto
     */
    createdDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof LegalDocumentDto
     */
    versionNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LegalDocumentDto
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {LegalDocumentType}
     * @memberof LegalDocumentDto
     */
    legalDocumentType?: LegalDocumentType | null;
}
/**
 * 
 * @export
 * @interface LegalDocumentType
 */
export interface LegalDocumentType extends Enumeration {
}
/**
 * 
 * @export
 * @interface LegalTextDto
 */
export interface LegalTextDto {
    /**
     * 
     * @type {string}
     * @memberof LegalTextDto
     */
    legalText?: string | null;
}
/**
 * 
 * @export
 * @interface LineOfBusiness
 */
export interface LineOfBusiness extends Enumeration {
}
/**
 * 
 * @export
 * @interface Link
 */
export interface Link {
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    href?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    rel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Link
     */
    verb?: string | null;
}
/**
 * 
 * @export
 * @interface LinkPreregisteredUserCommand
 */
export interface LinkPreregisteredUserCommand {
    /**
     * 
     * @type {string}
     * @memberof LinkPreregisteredUserCommand
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LinkPreregisteredUserCommand
     */
    key?: string | null;
}
/**
 * 
 * @export
 * @interface MessagingRole
 */
export interface MessagingRole extends RoleBase {
}
/**
 * 
 * @export
 * @interface MessagingUserTypeDto
 */
export interface MessagingUserTypeDto {
    /**
     * 
     * @type {UserStatus}
     * @memberof MessagingUserTypeDto
     */
    status?: UserStatus | null;
    /**
     * 
     * @type {Array<MessagingRole>}
     * @memberof MessagingUserTypeDto
     */
    roles?: Array<MessagingRole> | null;
}
/**
 * 
 * @export
 * @interface MobilePhoneUpdateRequestDto
 */
export interface MobilePhoneUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof MobilePhoneUpdateRequestDto
     */
    mobilePhone?: string | null;
}
/**
 * 
 * @export
 * @interface NameUpdateRequestDto
 */
export interface NameUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof NameUpdateRequestDto
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NameUpdateRequestDto
     */
    lastName?: string | null;
}
/**
 * 
 * @export
 * @interface PagedResultFieldSalesLeader
 */
export interface PagedResultFieldSalesLeader extends PagedResultOfFieldSalesLeaderDto {
}
/**
 * 
 * @export
 * @interface PagedResultOfAgentNumberUpdateRequestDto
 */
export interface PagedResultOfAgentNumberUpdateRequestDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentNumberUpdateRequestDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfAgentNumberUpdateRequestDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<AgentNumberUpdateRequestDto>}
     * @memberof PagedResultOfAgentNumberUpdateRequestDto
     */
    result?: Array<AgentNumberUpdateRequestDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfAgentNumberUpdateRequestDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfFieldSalesLeaderDto
 */
export interface PagedResultOfFieldSalesLeaderDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfFieldSalesLeaderDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfFieldSalesLeaderDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<FieldSalesLeaderDto>}
     * @memberof PagedResultOfFieldSalesLeaderDto
     */
    result?: Array<FieldSalesLeaderDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfFieldSalesLeaderDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfPreregisteredUserDto
 */
export interface PagedResultOfPreregisteredUserDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPreregisteredUserDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfPreregisteredUserDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<PreregisteredUserDto>}
     * @memberof PagedResultOfPreregisteredUserDto
     */
    result?: Array<PreregisteredUserDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfPreregisteredUserDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultOfUserDto
 */
export interface PagedResultOfUserDto {
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultOfUserDto
     */
    currentPageNumber?: number;
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof PagedResultOfUserDto
     */
    result?: Array<UserDto> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PagedResultOfUserDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface PagedResultPreregisteredUserDto
 */
export interface PagedResultPreregisteredUserDto extends PagedResultOfPreregisteredUserDto {
}
/**
 * 
 * @export
 * @interface PagedResultUser
 */
export interface PagedResultUser extends PagedResultOfUserDto {
}
/**
 * 
 * @export
 * @interface PasswordUpdateBySecurityQuestionRequestDto
 */
export interface PasswordUpdateBySecurityQuestionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordUpdateBySecurityQuestionRequestDto
     */
    requestKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordUpdateBySecurityQuestionRequestDto
     */
    password?: string | null;
    /**
     * 
     * @type {Array<SecurityQuestion>}
     * @memberof PasswordUpdateBySecurityQuestionRequestDto
     */
    securityQuestions?: Array<SecurityQuestion> | null;
}
/**
 * 
 * @export
 * @interface PasswordUpdateRequestDto
 */
export interface PasswordUpdateRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PasswordUpdateRequestDto
     */
    oldPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PasswordUpdateRequestDto
     */
    newPassword?: string | null;
}
/**
 * 
 * @export
 * @interface Position
 */
export interface Position extends Enumeration {
}
/**
 * 
 * @export
 * @interface PreregisteredAgentDetailDto
 */
export interface PreregisteredAgentDetailDto {
    /**
     * 
     * @type {Array<AgencyAssociationDto>}
     * @memberof PreregisteredAgentDetailDto
     */
    agencyAssociations?: Array<AgencyAssociationDto> | null;
}
/**
 * 
 * @export
 * @interface PreregisteredUserDetailDto
 */
export interface PreregisteredUserDetailDto {
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDetailDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDetailDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDetailDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDetailDto
     */
    email?: string | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof PreregisteredUserDetailDto
     */
    userTypes?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface PreregisteredUserDto
 */
export interface PreregisteredUserDto {
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreregisteredUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof PreregisteredUserDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface ProcessLogDto
 */
export interface ProcessLogDto {
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    processName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    machineName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadStartDateTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProcessLogDto
     */
    etlLoadEndDateTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessLogDto
     */
    elapsedTime?: string | null;
}
/**
 * 
 * @export
 * @interface RecruiterCode
 */
export interface RecruiterCode {
    /**
     * 
     * @type {string}
     * @memberof RecruiterCode
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RecruiterCode
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecruiterCode
     */
    isAhl?: boolean;
}
/**
 * 
 * @export
 * @interface RecruiterCodeAllOf
 */
export interface RecruiterCodeAllOf {
    /**
     * 
     * @type {string}
     * @memberof RecruiterCodeAllOf
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RecruiterCodeAllOf
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecruiterCodeAllOf
     */
    isAhl?: boolean;
}
/**
 * 
 * @export
 * @interface RecruiterCodeDto
 */
export interface RecruiterCodeDto {
    /**
     * 
     * @type {string}
     * @memberof RecruiterCodeDto
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RecruiterCodeDto
     */
    isNewYork?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecruiterCodeDto
     */
    isAhl?: boolean;
}
/**
 * 
 * @export
 * @interface RoleBase
 */
export interface RoleBase extends Enumeration {
}
/**
 * 
 * @export
 * @interface SecurityQuestion
 */
export interface SecurityQuestion {
    /**
     * 
     * @type {string}
     * @memberof SecurityQuestion
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityQuestion
     */
    question?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityQuestion
     */
    response?: string | null;
}
/**
 * 
 * @export
 * @interface SecurityQuestionWithoutAnswer
 */
export interface SecurityQuestionWithoutAnswer {
    /**
     * 
     * @type {string}
     * @memberof SecurityQuestionWithoutAnswer
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SecurityQuestionWithoutAnswer
     */
    question?: string | null;
}
/**
 * 
 * @export
 * @interface SsoAccountDto
 */
export interface SsoAccountDto {
    /**
     * 
     * @type {string}
     * @memberof SsoAccountDto
     */
    username?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SsoAccountDto
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {Array<Link>}
     * @memberof SsoAccountDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface SsoInsertDto
 */
export interface SsoInsertDto {
    /**
     * 
     * @type {string}
     * @memberof SsoInsertDto
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoInsertDto
     */
    password?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SsoInsertDto
     */
    isPrimary?: boolean;
}
/**
 * 
 * @export
 * @interface SsoResponseDto
 */
export interface SsoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SsoResponseDto
     */
    url?: string | null;
    /**
     * 
     * @type {Link}
     * @memberof SsoResponseDto
     */
    link?: Link | null;
}
/**
 * 
 * @export
 * @interface SsoUpdateDto
 */
export interface SsoUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof SsoUpdateDto
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SsoUpdateDto
     */
    password?: string | null;
}
/**
 * 
 * @export
 * @interface UnlockAccountBySecurityQuestionsRequestDto
 */
export interface UnlockAccountBySecurityQuestionsRequestDto {
    /**
     * 
     * @type {Array<SecurityQuestion>}
     * @memberof UnlockAccountBySecurityQuestionsRequestDto
     */
    securityQuestions?: Array<SecurityQuestion> | null;
}
/**
 * 
 * @export
 * @interface UpdateSecurityQuestionsRequestDto
 */
export interface UpdateSecurityQuestionsRequestDto {
    /**
     * 
     * @type {Array<SecurityQuestion>}
     * @memberof UpdateSecurityQuestionsRequestDto
     */
    securityQuestions?: Array<SecurityQuestion> | null;
}
/**
 * 
 * @export
 * @interface UserClaim
 */
export interface UserClaim {
    /**
     * 
     * @type {string}
     * @memberof UserClaim
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserClaim
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserClaim
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserClaim
     */
    lastName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserClaim
     */
    shouldResetPassword?: boolean;
    /**
     * 
     * @type {Array<LegalDocumentClaim>}
     * @memberof UserClaim
     */
    unacceptedLegalDocuments?: Array<LegalDocumentClaim> | null;
    /**
     * 
     * @type {ExclusivityStatus}
     * @memberof UserClaim
     */
    exclusivityStatus?: ExclusivityStatus | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof UserClaim
     */
    userTypes?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface UserDetailDto
 */
export interface UserDetailDto {
    /**
     * 
     * @type {string}
     * @memberof UserDetailDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDetailDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {ExclusivityStatus}
     * @memberof UserDetailDto
     */
    exclusivityStatus?: ExclusivityStatus | null;
    /**
     * 
     * @type {Array<object>}
     * @memberof UserDetailDto
     */
    userTypes?: Array<object> | null;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    email?: string | null;
    /**
     * 
     * @type {ExclusivityStatus}
     * @memberof UserDto
     */
    exclusivityStatus?: ExclusivityStatus | null;
    /**
     * 
     * @type {Array<LineOfBusiness>}
     * @memberof UserDto
     */
    linesOfBusiness?: Array<LineOfBusiness> | null;
    /**
     * 
     * @type {Array<Link>}
     * @memberof UserDto
     */
    links?: Array<Link> | null;
}
/**
 * 
 * @export
 * @interface UserEntryDto
 */
export interface UserEntryDto {
    /**
     * 
     * @type {string}
     * @memberof UserEntryDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntryDto
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntryDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntryDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntryDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserEntryDto
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {ExclusivityStatus}
     * @memberof UserEntryDto
     */
    exclusivityStatus?: ExclusivityStatus | null;
    /**
     * 
     * @type {ApplicationEntryUserTypeDto}
     * @memberof UserEntryDto
     */
    applicationEntryUser?: ApplicationEntryUserTypeDto | null;
    /**
     * 
     * @type {BusinessOperationsSupportUserTypeDto}
     * @memberof UserEntryDto
     */
    businessOperationsSupportUser?: BusinessOperationsSupportUserTypeDto | null;
    /**
     * 
     * @type {BeneficiaryUserTypeDto}
     * @memberof UserEntryDto
     */
    beneficiaryUser?: BeneficiaryUserTypeDto | null;
    /**
     * 
     * @type {EnrollTrackUserTypeDto}
     * @memberof UserEntryDto
     */
    enrollTrackUser?: EnrollTrackUserTypeDto | null;
    /**
     * 
     * @type {MessagingUserTypeDto}
     * @memberof UserEntryDto
     */
    messagingUser?: MessagingUserTypeDto | null;
    /**
     * 
     * @type {AgentUserTypeDto}
     * @memberof UserEntryDto
     */
    agentUser?: AgentUserTypeDto | null;
}
/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    mobilePhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    position?: string | null;
    /**
     * 
     * @type {Array<SecurityQuestion>}
     * @memberof UserProfile
     */
    securityQuestions?: Array<SecurityQuestion> | null;
}
/**
 * 
 * @export
 * @interface UserStatus
 */
export interface UserStatus extends Enumeration {
}

/**
 * AgencyApi - axios parameter creator
 * @export
 */
export const AgencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {AgencyAssociationRequestDto} agencyAssociationRequestDto 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyUpdate: async (userName: string, version: string, agencyAssociationRequestDto: AgencyAssociationRequestDto, encryptedIdentifier?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new RequiredError('userName','Required parameter userName was null or undefined when calling agencyUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agencyUpdate.');
            }
            // verify required parameter 'agencyAssociationRequestDto' is not null or undefined
            if (agencyAssociationRequestDto === null || agencyAssociationRequestDto === undefined) {
                throw new RequiredError('agencyAssociationRequestDto','Required parameter agencyAssociationRequestDto was null or undefined when calling agencyUpdate.');
            }
            const localVarPath = `/api/v{version}/users/agency/agent/{username}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (encryptedIdentifier !== undefined) {
                localVarQueryParameter['encryptedIdentifier'] = encryptedIdentifier;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof agencyAssociationRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(agencyAssociationRequestDto !== undefined ? agencyAssociationRequestDto : {}) : (agencyAssociationRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyApi - functional programming interface
 * @export
 */
export const AgencyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {AgencyAssociationRequestDto} agencyAssociationRequestDto 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyUpdate(userName: string, version: string, agencyAssociationRequestDto: AgencyAssociationRequestDto, encryptedIdentifier?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await AgencyApiAxiosParamCreator(configuration).agencyUpdate(userName, version, agencyAssociationRequestDto, encryptedIdentifier, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgencyApi - factory interface
 * @export
 */
export const AgencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {AgencyAssociationRequestDto} agencyAssociationRequestDto 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyUpdate(userName: string, version: string, agencyAssociationRequestDto: AgencyAssociationRequestDto, encryptedIdentifier?: string, options?: any): AxiosPromise<UserDetailDto> {
            return AgencyApiFp(configuration).agencyUpdate(userName, version, agencyAssociationRequestDto, encryptedIdentifier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgencyApi - object-oriented interface
 * @export
 * @class AgencyApi
 * @extends {BaseAPI}
 */
export class AgencyApi extends BaseAPI {
    /**
     * 
     * @param {string} userName 
     * @param {string} version 
     * @param {AgencyAssociationRequestDto} agencyAssociationRequestDto 
     * @param {string} [encryptedIdentifier] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyUpdate(userName: string, version: string, agencyAssociationRequestDto: AgencyAssociationRequestDto, encryptedIdentifier?: string, options?: any) {
        return AgencyApiFp(this.configuration).agencyUpdate(userName, version, agencyAssociationRequestDto, encryptedIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentApi - axios parameter creator
 * @export
 */
export const AgentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentGet.');
            }
            const localVarPath = `/api/v{version}/users/agents`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {EditAgentRequestDto} editAgentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUpdate: async (version: string, editAgentRequestDto: EditAgentRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentUpdate.');
            }
            // verify required parameter 'editAgentRequestDto' is not null or undefined
            if (editAgentRequestDto === null || editAgentRequestDto === undefined) {
                throw new RequiredError('editAgentRequestDto','Required parameter editAgentRequestDto was null or undefined when calling agentUpdate.');
            }
            const localVarPath = `/api/v{version}/users/agents`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof editAgentRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(editAgentRequestDto !== undefined ? editAgentRequestDto : {}) : (editAgentRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentApi - functional programming interface
 * @export
 */
export const AgentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultUser>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).agentGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {EditAgentRequestDto} editAgentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentUpdate(version: string, editAgentRequestDto: EditAgentRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await AgentApiAxiosParamCreator(configuration).agentUpdate(version, editAgentRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentApi - factory interface
 * @export
 */
export const AgentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentGet(version: string, options?: any): AxiosPromise<PagedResultUser> {
            return AgentApiFp(configuration).agentGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {EditAgentRequestDto} editAgentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUpdate(version: string, editAgentRequestDto: EditAgentRequestDto, options?: any): AxiosPromise<UserDetailDto> {
            return AgentApiFp(configuration).agentUpdate(version, editAgentRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentApi - object-oriented interface
 * @export
 * @class AgentApi
 * @extends {BaseAPI}
 */
export class AgentApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public agentGet(version: string, options?: any) {
        return AgentApiFp(this.configuration).agentGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {EditAgentRequestDto} editAgentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentApi
     */
    public agentUpdate(version: string, editAgentRequestDto: EditAgentRequestDto, options?: any) {
        return AgentApiFp(this.configuration).agentUpdate(version, editAgentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentNumberApi - axios parameter creator
 * @export
 */
export const AgentNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberGetByEncryptedIdentifier: async (version: string, encryptedIdentifier?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNumberGetByEncryptedIdentifier.');
            }
            const localVarPath = `/api/v{version}/users/agentnumbers/encryptedidentifier`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (encryptedIdentifier !== undefined) {
                localVarQueryParameter['encryptedIdentifier'] = encryptedIdentifier;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberGetByIdentifier: async (identifier: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new RequiredError('identifier','Required parameter identifier was null or undefined when calling agentNumberGetByIdentifier.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNumberGetByIdentifier.');
            }
            const localVarPath = `/api/v{version}/users/agentnumbers/identifier/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentNumberApi - functional programming interface
 * @export
 */
export const AgentNumberApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentNumberGetByEncryptedIdentifier(version: string, encryptedIdentifier?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentNumberWithStatusDto>>> {
            const localVarAxiosArgs = await AgentNumberApiAxiosParamCreator(configuration).agentNumberGetByEncryptedIdentifier(version, encryptedIdentifier, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} identifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentNumberGetByIdentifier(identifier: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentNumberWithStatusDto>>> {
            const localVarAxiosArgs = await AgentNumberApiAxiosParamCreator(configuration).agentNumberGetByIdentifier(identifier, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentNumberApi - factory interface
 * @export
 */
export const AgentNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberGetByEncryptedIdentifier(version: string, encryptedIdentifier?: string, options?: any): AxiosPromise<Array<AgentNumberWithStatusDto>> {
            return AgentNumberApiFp(configuration).agentNumberGetByEncryptedIdentifier(version, encryptedIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberGetByIdentifier(identifier: string, version: string, options?: any): AxiosPromise<Array<AgentNumberWithStatusDto>> {
            return AgentNumberApiFp(configuration).agentNumberGetByIdentifier(identifier, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentNumberApi - object-oriented interface
 * @export
 * @class AgentNumberApi
 * @extends {BaseAPI}
 */
export class AgentNumberApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [encryptedIdentifier] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberApi
     */
    public agentNumberGetByEncryptedIdentifier(version: string, encryptedIdentifier?: string, options?: any) {
        return AgentNumberApiFp(this.configuration).agentNumberGetByEncryptedIdentifier(version, encryptedIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identifier 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberApi
     */
    public agentNumberGetByIdentifier(identifier: string, version: string, options?: any) {
        return AgentNumberApiFp(this.configuration).agentNumberGetByIdentifier(identifier, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentNumberAssociationApi - axios parameter creator
 * @export
 */
export const AgentNumberAssociationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberAssociationAgentNumberAssociationETLReset: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNumberAssociationAgentNumberAssociationETLReset.');
            }
            const localVarPath = `/api/v{version}/users/agentNumberAssociation/etl/reset`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentNumberAssociationApi - functional programming interface
 * @export
 */
export const AgentNumberAssociationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentNumberAssociationAgentNumberAssociationETLReset(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AgentNumberAssociationApiAxiosParamCreator(configuration).agentNumberAssociationAgentNumberAssociationETLReset(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentNumberAssociationApi - factory interface
 * @export
 */
export const AgentNumberAssociationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberAssociationAgentNumberAssociationETLReset(version: string, options?: any): AxiosPromise<void> {
            return AgentNumberAssociationApiFp(configuration).agentNumberAssociationAgentNumberAssociationETLReset(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentNumberAssociationApi - object-oriented interface
 * @export
 * @class AgentNumberAssociationApi
 * @extends {BaseAPI}
 */
export class AgentNumberAssociationApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberAssociationApi
     */
    public agentNumberAssociationAgentNumberAssociationETLReset(version: string, options?: any) {
        return AgentNumberAssociationApiFp(this.configuration).agentNumberAssociationAgentNumberAssociationETLReset(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentNumberUpdateRequestApi - axios parameter creator
 * @export
 */
export const AgentNumberUpdateRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates.');
            }
            const localVarPath = `/api/v{version}/users/AgentNumberUpdateRequests/etl`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [isComplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberUpdateRequestSetIsComplete: async (id: string, version: string, isComplete?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agentNumberUpdateRequestSetIsComplete.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentNumberUpdateRequestSetIsComplete.');
            }
            const localVarPath = `/api/v{version}/users/AgentNumberUpdateRequests/{id}/set/iscomplete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (isComplete !== undefined) {
                localVarQueryParameter['isComplete'] = isComplete;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentNumberUpdateRequest: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteAgentNumberUpdateRequest.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling deleteAgentNumberUpdateRequest.');
            }
            const localVarPath = `/api/v{version}/users/AgentNumberUpdateRequests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentNumberUpdateRequest: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchAgentNumberUpdateRequest.');
            }
            const localVarPath = `/api/v{version}/users/AgentNumberUpdateRequests`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentNumberUpdateRequestApi - functional programming interface
 * @export
 */
export const AgentNumberUpdateRequestApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AgentNumberUpdateRequestApiAxiosParamCreator(configuration).agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [isComplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentNumberUpdateRequestSetIsComplete(id: string, version: string, isComplete?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AgentNumberUpdateRequestApiAxiosParamCreator(configuration).agentNumberUpdateRequestSetIsComplete(id, version, isComplete, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgentNumberUpdateRequest(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await AgentNumberUpdateRequestApiAxiosParamCreator(configuration).deleteAgentNumberUpdateRequest(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAgentNumberUpdateRequest(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfAgentNumberUpdateRequestDto>> {
            const localVarAxiosArgs = await AgentNumberUpdateRequestApiAxiosParamCreator(configuration).searchAgentNumberUpdateRequest(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentNumberUpdateRequestApi - factory interface
 * @export
 */
export const AgentNumberUpdateRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates(version: string, options?: any): AxiosPromise<void> {
            return AgentNumberUpdateRequestApiFp(configuration).agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [isComplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentNumberUpdateRequestSetIsComplete(id: string, version: string, isComplete?: boolean, options?: any): AxiosPromise<void> {
            return AgentNumberUpdateRequestApiFp(configuration).agentNumberUpdateRequestSetIsComplete(id, version, isComplete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgentNumberUpdateRequest(id: string, version: string, options?: any): AxiosPromise<void> {
            return AgentNumberUpdateRequestApiFp(configuration).deleteAgentNumberUpdateRequest(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAgentNumberUpdateRequest(version: string, options?: any): AxiosPromise<PagedResultOfAgentNumberUpdateRequestDto> {
            return AgentNumberUpdateRequestApiFp(configuration).searchAgentNumberUpdateRequest(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentNumberUpdateRequestApi - object-oriented interface
 * @export
 * @class AgentNumberUpdateRequestApi
 * @extends {BaseAPI}
 */
export class AgentNumberUpdateRequestApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberUpdateRequestApi
     */
    public agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates(version: string, options?: any) {
        return AgentNumberUpdateRequestApiFp(this.configuration).agentNumberUpdateRequestProcessIdentifierAgentNumberUpdates(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {boolean} [isComplete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberUpdateRequestApi
     */
    public agentNumberUpdateRequestSetIsComplete(id: string, version: string, isComplete?: boolean, options?: any) {
        return AgentNumberUpdateRequestApiFp(this.configuration).agentNumberUpdateRequestSetIsComplete(id, version, isComplete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberUpdateRequestApi
     */
    public deleteAgentNumberUpdateRequest(id: string, version: string, options?: any) {
        return AgentNumberUpdateRequestApiFp(this.configuration).deleteAgentNumberUpdateRequest(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentNumberUpdateRequestApi
     */
    public searchAgentNumberUpdateRequest(version: string, options?: any) {
        return AgentNumberUpdateRequestApiFp(this.configuration).searchAgentNumberUpdateRequest(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * AgentUserApi - axios parameter creator
 * @export
 */
export const AgentUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUserDelete: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling agentUserDelete.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentUserDelete.');
            }
            const localVarPath = `/api/v{version}/users/agents/{id}/internal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {AddAgentUserDto} addAgentUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUserInsert: async (version: string, addAgentUserDto: AddAgentUserDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentUserInsert.');
            }
            // verify required parameter 'addAgentUserDto' is not null or undefined
            if (addAgentUserDto === null || addAgentUserDto === undefined) {
                throw new RequiredError('addAgentUserDto','Required parameter addAgentUserDto was null or undefined when calling agentUserInsert.');
            }
            const localVarPath = `/api/v{version}/users/agents/internal`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addAgentUserDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addAgentUserDto !== undefined ? addAgentUserDto : {}) : (addAgentUserDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {EditAgentUserDto} editAgentUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUserUpdate: async (version: string, editAgentUserDto: EditAgentUserDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling agentUserUpdate.');
            }
            // verify required parameter 'editAgentUserDto' is not null or undefined
            if (editAgentUserDto === null || editAgentUserDto === undefined) {
                throw new RequiredError('editAgentUserDto','Required parameter editAgentUserDto was null or undefined when calling agentUserUpdate.');
            }
            const localVarPath = `/api/v{version}/users/agents/internal`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof editAgentUserDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(editAgentUserDto !== undefined ? editAgentUserDto : {}) : (editAgentUserDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgentUserApi - functional programming interface
 * @export
 */
export const AgentUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentUserDelete(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await AgentUserApiAxiosParamCreator(configuration).agentUserDelete(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {AddAgentUserDto} addAgentUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentUserInsert(version: string, addAgentUserDto: AddAgentUserDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await AgentUserApiAxiosParamCreator(configuration).agentUserInsert(version, addAgentUserDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {EditAgentUserDto} editAgentUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentUserUpdate(version: string, editAgentUserDto: EditAgentUserDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await AgentUserApiAxiosParamCreator(configuration).agentUserUpdate(version, editAgentUserDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AgentUserApi - factory interface
 * @export
 */
export const AgentUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUserDelete(id: string, version: string, options?: any): AxiosPromise<any> {
            return AgentUserApiFp(configuration).agentUserDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {AddAgentUserDto} addAgentUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUserInsert(version: string, addAgentUserDto: AddAgentUserDto, options?: any): AxiosPromise<UserDetailDto> {
            return AgentUserApiFp(configuration).agentUserInsert(version, addAgentUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {EditAgentUserDto} editAgentUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentUserUpdate(version: string, editAgentUserDto: EditAgentUserDto, options?: any): AxiosPromise<UserDetailDto> {
            return AgentUserApiFp(configuration).agentUserUpdate(version, editAgentUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgentUserApi - object-oriented interface
 * @export
 * @class AgentUserApi
 * @extends {BaseAPI}
 */
export class AgentUserApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentUserApi
     */
    public agentUserDelete(id: string, version: string, options?: any) {
        return AgentUserApiFp(this.configuration).agentUserDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {AddAgentUserDto} addAgentUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentUserApi
     */
    public agentUserInsert(version: string, addAgentUserDto: AddAgentUserDto, options?: any) {
        return AgentUserApiFp(this.configuration).agentUserInsert(version, addAgentUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {EditAgentUserDto} editAgentUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgentUserApi
     */
    public agentUserUpdate(version: string, editAgentUserDto: EditAgentUserDto, options?: any) {
        return AgentUserApiFp(this.configuration).agentUserUpdate(version, editAgentUserDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BeneficiaryUserApi - axios parameter creator
 * @export
 */
export const BeneficiaryUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddBeneficiaryUserDto} addBeneficiaryUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beneficiaryUserInsert: async (version: string, addBeneficiaryUserDto: AddBeneficiaryUserDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling beneficiaryUserInsert.');
            }
            // verify required parameter 'addBeneficiaryUserDto' is not null or undefined
            if (addBeneficiaryUserDto === null || addBeneficiaryUserDto === undefined) {
                throw new RequiredError('addBeneficiaryUserDto','Required parameter addBeneficiaryUserDto was null or undefined when calling beneficiaryUserInsert.');
            }
            const localVarPath = `/api/v{version}/users/beneficiary`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addBeneficiaryUserDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addBeneficiaryUserDto !== undefined ? addBeneficiaryUserDto : {}) : (addBeneficiaryUserDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BeneficiaryUserApi - functional programming interface
 * @export
 */
export const BeneficiaryUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddBeneficiaryUserDto} addBeneficiaryUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async beneficiaryUserInsert(version: string, addBeneficiaryUserDto: AddBeneficiaryUserDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await BeneficiaryUserApiAxiosParamCreator(configuration).beneficiaryUserInsert(version, addBeneficiaryUserDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BeneficiaryUserApi - factory interface
 * @export
 */
export const BeneficiaryUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddBeneficiaryUserDto} addBeneficiaryUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beneficiaryUserInsert(version: string, addBeneficiaryUserDto: AddBeneficiaryUserDto, options?: any): AxiosPromise<UserDetailDto> {
            return BeneficiaryUserApiFp(configuration).beneficiaryUserInsert(version, addBeneficiaryUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BeneficiaryUserApi - object-oriented interface
 * @export
 * @class BeneficiaryUserApi
 * @extends {BaseAPI}
 */
export class BeneficiaryUserApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddBeneficiaryUserDto} addBeneficiaryUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BeneficiaryUserApi
     */
    public beneficiaryUserInsert(version: string, addBeneficiaryUserDto: AddBeneficiaryUserDto, options?: any) {
        return BeneficiaryUserApiFp(this.configuration).beneficiaryUserInsert(version, addBeneficiaryUserDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * BusinessOperationsSupportUserApi - axios parameter creator
 * @export
 */
export const BusinessOperationsSupportUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddBusinessOperationsSupportDto} addBusinessOperationsSupportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessOperationsSupportUserInsert: async (version: string, addBusinessOperationsSupportDto: AddBusinessOperationsSupportDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling businessOperationsSupportUserInsert.');
            }
            // verify required parameter 'addBusinessOperationsSupportDto' is not null or undefined
            if (addBusinessOperationsSupportDto === null || addBusinessOperationsSupportDto === undefined) {
                throw new RequiredError('addBusinessOperationsSupportDto','Required parameter addBusinessOperationsSupportDto was null or undefined when calling businessOperationsSupportUserInsert.');
            }
            const localVarPath = `/api/v{version}/users/businessoperationssupport`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addBusinessOperationsSupportDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addBusinessOperationsSupportDto !== undefined ? addBusinessOperationsSupportDto : {}) : (addBusinessOperationsSupportDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BusinessOperationsSupportUserApi - functional programming interface
 * @export
 */
export const BusinessOperationsSupportUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddBusinessOperationsSupportDto} addBusinessOperationsSupportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async businessOperationsSupportUserInsert(version: string, addBusinessOperationsSupportDto: AddBusinessOperationsSupportDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await BusinessOperationsSupportUserApiAxiosParamCreator(configuration).businessOperationsSupportUserInsert(version, addBusinessOperationsSupportDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * BusinessOperationsSupportUserApi - factory interface
 * @export
 */
export const BusinessOperationsSupportUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddBusinessOperationsSupportDto} addBusinessOperationsSupportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessOperationsSupportUserInsert(version: string, addBusinessOperationsSupportDto: AddBusinessOperationsSupportDto, options?: any): AxiosPromise<UserDetailDto> {
            return BusinessOperationsSupportUserApiFp(configuration).businessOperationsSupportUserInsert(version, addBusinessOperationsSupportDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BusinessOperationsSupportUserApi - object-oriented interface
 * @export
 * @class BusinessOperationsSupportUserApi
 * @extends {BaseAPI}
 */
export class BusinessOperationsSupportUserApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddBusinessOperationsSupportDto} addBusinessOperationsSupportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessOperationsSupportUserApi
     */
    public businessOperationsSupportUserInsert(version: string, addBusinessOperationsSupportDto: AddBusinessOperationsSupportDto, options?: any) {
        return BusinessOperationsSupportUserApiFp(this.configuration).businessOperationsSupportUserInsert(version, addBusinessOperationsSupportDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ClaimsApi - axios parameter creator
 * @export
 */
export const ClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGet: async (username: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling claimsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling claimsGet.');
            }
            const localVarPath = `/api/v{version}/users/{username}/claims`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimsApi - functional programming interface
 * @export
 */
export const ClaimsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimsGet(username: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserClaim>> {
            const localVarAxiosArgs = await ClaimsApiAxiosParamCreator(configuration).claimsGet(username, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClaimsApi - factory interface
 * @export
 */
export const ClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGet(username: string, version: string, options?: any): AxiosPromise<UserClaim> {
            return ClaimsApiFp(configuration).claimsGet(username, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimsApi - object-oriented interface
 * @export
 * @class ClaimsApi
 * @extends {BaseAPI}
 */
export class ClaimsApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApi
     */
    public claimsGet(username: string, version: string, options?: any) {
        return ClaimsApiFp(this.configuration).claimsGet(username, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * CustomerSupportApi - axios parameter creator
 * @export
 */
export const CustomerSupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSupportSearch: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling customerSupportSearch.');
            }
            const localVarPath = `/api/v{version}/users/customersupport`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerSupportApi - functional programming interface
 * @export
 */
export const CustomerSupportApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerSupportSearch(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfUserDto>> {
            const localVarAxiosArgs = await CustomerSupportApiAxiosParamCreator(configuration).customerSupportSearch(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CustomerSupportApi - factory interface
 * @export
 */
export const CustomerSupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerSupportSearch(version: string, options?: any): AxiosPromise<PagedResultOfUserDto> {
            return CustomerSupportApiFp(configuration).customerSupportSearch(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerSupportApi - object-oriented interface
 * @export
 * @class CustomerSupportApi
 * @extends {BaseAPI}
 */
export class CustomerSupportApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerSupportApi
     */
    public customerSupportSearch(version: string, options?: any) {
        return CustomerSupportApiFp(this.configuration).customerSupportSearch(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * EnrollTrackUserApi - axios parameter creator
 * @export
 */
export const EnrollTrackUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddEnrollTrackUserRequestDto} addEnrollTrackUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollTrackUserInsert: async (version: string, addEnrollTrackUserRequestDto: AddEnrollTrackUserRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling enrollTrackUserInsert.');
            }
            // verify required parameter 'addEnrollTrackUserRequestDto' is not null or undefined
            if (addEnrollTrackUserRequestDto === null || addEnrollTrackUserRequestDto === undefined) {
                throw new RequiredError('addEnrollTrackUserRequestDto','Required parameter addEnrollTrackUserRequestDto was null or undefined when calling enrollTrackUserInsert.');
            }
            const localVarPath = `/api/v{version}/users/enrollTrack`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addEnrollTrackUserRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addEnrollTrackUserRequestDto !== undefined ? addEnrollTrackUserRequestDto : {}) : (addEnrollTrackUserRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EnrollTrackUserApi - functional programming interface
 * @export
 */
export const EnrollTrackUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddEnrollTrackUserRequestDto} addEnrollTrackUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollTrackUserInsert(version: string, addEnrollTrackUserRequestDto: AddEnrollTrackUserRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await EnrollTrackUserApiAxiosParamCreator(configuration).enrollTrackUserInsert(version, addEnrollTrackUserRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EnrollTrackUserApi - factory interface
 * @export
 */
export const EnrollTrackUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddEnrollTrackUserRequestDto} addEnrollTrackUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollTrackUserInsert(version: string, addEnrollTrackUserRequestDto: AddEnrollTrackUserRequestDto, options?: any): AxiosPromise<UserDetailDto> {
            return EnrollTrackUserApiFp(configuration).enrollTrackUserInsert(version, addEnrollTrackUserRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EnrollTrackUserApi - object-oriented interface
 * @export
 * @class EnrollTrackUserApi
 * @extends {BaseAPI}
 */
export class EnrollTrackUserApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddEnrollTrackUserRequestDto} addEnrollTrackUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnrollTrackUserApi
     */
    public enrollTrackUserInsert(version: string, addEnrollTrackUserRequestDto: AddEnrollTrackUserRequestDto, options?: any) {
        return EnrollTrackUserApiFp(this.configuration).enrollTrackUserInsert(version, addEnrollTrackUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExclusiveAgentUserApi - axios parameter creator
 * @export
 */
export const ExclusiveAgentUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddExclusiveAgentRequest} addExclusiveAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exclusiveAgentUserInsert: async (version: string, addExclusiveAgentRequest: AddExclusiveAgentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling exclusiveAgentUserInsert.');
            }
            // verify required parameter 'addExclusiveAgentRequest' is not null or undefined
            if (addExclusiveAgentRequest === null || addExclusiveAgentRequest === undefined) {
                throw new RequiredError('addExclusiveAgentRequest','Required parameter addExclusiveAgentRequest was null or undefined when calling exclusiveAgentUserInsert.');
            }
            const localVarPath = `/api/v{version}/users/agents/exclusive`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addExclusiveAgentRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addExclusiveAgentRequest !== undefined ? addExclusiveAgentRequest : {}) : (addExclusiveAgentRequest || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExclusiveAgentUserApi - functional programming interface
 * @export
 */
export const ExclusiveAgentUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddExclusiveAgentRequest} addExclusiveAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exclusiveAgentUserInsert(version: string, addExclusiveAgentRequest: AddExclusiveAgentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await ExclusiveAgentUserApiAxiosParamCreator(configuration).exclusiveAgentUserInsert(version, addExclusiveAgentRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExclusiveAgentUserApi - factory interface
 * @export
 */
export const ExclusiveAgentUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddExclusiveAgentRequest} addExclusiveAgentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exclusiveAgentUserInsert(version: string, addExclusiveAgentRequest: AddExclusiveAgentRequest, options?: any): AxiosPromise<UserDetailDto> {
            return ExclusiveAgentUserApiFp(configuration).exclusiveAgentUserInsert(version, addExclusiveAgentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExclusiveAgentUserApi - object-oriented interface
 * @export
 * @class ExclusiveAgentUserApi
 * @extends {BaseAPI}
 */
export class ExclusiveAgentUserApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddExclusiveAgentRequest} addExclusiveAgentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExclusiveAgentUserApi
     */
    public exclusiveAgentUserInsert(version: string, addExclusiveAgentRequest: AddExclusiveAgentRequest, options?: any) {
        return ExclusiveAgentUserApiFp(this.configuration).exclusiveAgentUserInsert(version, addExclusiveAgentRequest, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExternalUserApi - axios parameter creator
 * @export
 */
export const ExternalUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddIndependentAgentRequestDto} addIndependentAgentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUserInsert: async (version: string, addIndependentAgentRequestDto: AddIndependentAgentRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalUserInsert.');
            }
            // verify required parameter 'addIndependentAgentRequestDto' is not null or undefined
            if (addIndependentAgentRequestDto === null || addIndependentAgentRequestDto === undefined) {
                throw new RequiredError('addIndependentAgentRequestDto','Required parameter addIndependentAgentRequestDto was null or undefined when calling externalUserInsert.');
            }
            const localVarPath = `/api/v{version}/users/external`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addIndependentAgentRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addIndependentAgentRequestDto !== undefined ? addIndependentAgentRequestDto : {}) : (addIndependentAgentRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {AddPreregisteredAgentCommand} addPreregisteredAgentCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUserPreregister: async (version: string, addPreregisteredAgentCommand: AddPreregisteredAgentCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalUserPreregister.');
            }
            // verify required parameter 'addPreregisteredAgentCommand' is not null or undefined
            if (addPreregisteredAgentCommand === null || addPreregisteredAgentCommand === undefined) {
                throw new RequiredError('addPreregisteredAgentCommand','Required parameter addPreregisteredAgentCommand was null or undefined when calling externalUserPreregister.');
            }
            const localVarPath = `/api/v{version}/users/external/preregister`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof addPreregisteredAgentCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addPreregisteredAgentCommand !== undefined ? addPreregisteredAgentCommand : {}) : (addPreregisteredAgentCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalUserApi - functional programming interface
 * @export
 */
export const ExternalUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddIndependentAgentRequestDto} addIndependentAgentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalUserInsert(version: string, addIndependentAgentRequestDto: AddIndependentAgentRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExternalUserApiAxiosParamCreator(configuration).externalUserInsert(version, addIndependentAgentRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {AddPreregisteredAgentCommand} addPreregisteredAgentCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalUserPreregister(version: string, addPreregisteredAgentCommand: AddPreregisteredAgentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExternalUserApiAxiosParamCreator(configuration).externalUserPreregister(version, addPreregisteredAgentCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalUserApi - factory interface
 * @export
 */
export const ExternalUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {AddIndependentAgentRequestDto} addIndependentAgentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUserInsert(version: string, addIndependentAgentRequestDto: AddIndependentAgentRequestDto, options?: any): AxiosPromise<void> {
            return ExternalUserApiFp(configuration).externalUserInsert(version, addIndependentAgentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {AddPreregisteredAgentCommand} addPreregisteredAgentCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalUserPreregister(version: string, addPreregisteredAgentCommand: AddPreregisteredAgentCommand, options?: any): AxiosPromise<void> {
            return ExternalUserApiFp(configuration).externalUserPreregister(version, addPreregisteredAgentCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalUserApi - object-oriented interface
 * @export
 * @class ExternalUserApi
 * @extends {BaseAPI}
 */
export class ExternalUserApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {AddIndependentAgentRequestDto} addIndependentAgentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalUserApi
     */
    public externalUserInsert(version: string, addIndependentAgentRequestDto: AddIndependentAgentRequestDto, options?: any) {
        return ExternalUserApiFp(this.configuration).externalUserInsert(version, addIndependentAgentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {AddPreregisteredAgentCommand} addPreregisteredAgentCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalUserApi
     */
    public externalUserPreregister(version: string, addPreregisteredAgentCommand: AddPreregisteredAgentCommand, options?: any) {
        return ExternalUserApiFp(this.configuration).externalUserPreregister(version, addPreregisteredAgentCommand, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ExternalValidateApi - axios parameter creator
 * @export
 */
export const ExternalValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalValidateValidateEmail: async (key: string, email: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling externalValidateValidateEmail.');
            }
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling externalValidateValidateEmail.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalValidateValidateEmail.');
            }
            const localVarPath = `/api/v{version}/users/external/validate/key/{key}/email/{email}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"email"}}`, encodeURIComponent(String(email)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalValidateValidateMobilePhone: async (key: string, mobilePhone: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling externalValidateValidateMobilePhone.');
            }
            // verify required parameter 'mobilePhone' is not null or undefined
            if (mobilePhone === null || mobilePhone === undefined) {
                throw new RequiredError('mobilePhone','Required parameter mobilePhone was null or undefined when calling externalValidateValidateMobilePhone.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalValidateValidateMobilePhone.');
            }
            const localVarPath = `/api/v{version}/users/external/validate/key/{key}/mobilephone/{mobilePhone}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"mobilePhone"}}`, encodeURIComponent(String(mobilePhone)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalValidateValidateUserName: async (key: string, userName: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling externalValidateValidateUserName.');
            }
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new RequiredError('userName','Required parameter userName was null or undefined when calling externalValidateValidateUserName.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling externalValidateValidateUserName.');
            }
            const localVarPath = `/api/v{version}/users/external/validate/key/{key}/username/{userName}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalValidateApi - functional programming interface
 * @export
 */
export const ExternalValidateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalValidateValidateEmail(key: string, email: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExternalValidateApiAxiosParamCreator(configuration).externalValidateValidateEmail(key, email, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalValidateValidateMobilePhone(key: string, mobilePhone: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExternalValidateApiAxiosParamCreator(configuration).externalValidateValidateMobilePhone(key, mobilePhone, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalValidateValidateUserName(key: string, userName: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ExternalValidateApiAxiosParamCreator(configuration).externalValidateValidateUserName(key, userName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ExternalValidateApi - factory interface
 * @export
 */
export const ExternalValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalValidateValidateEmail(key: string, email: string, version: string, options?: any): AxiosPromise<void> {
            return ExternalValidateApiFp(configuration).externalValidateValidateEmail(key, email, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalValidateValidateMobilePhone(key: string, mobilePhone: string, version: string, options?: any): AxiosPromise<void> {
            return ExternalValidateApiFp(configuration).externalValidateValidateMobilePhone(key, mobilePhone, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalValidateValidateUserName(key: string, userName: string, version: string, options?: any): AxiosPromise<void> {
            return ExternalValidateApiFp(configuration).externalValidateValidateUserName(key, userName, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalValidateApi - object-oriented interface
 * @export
 * @class ExternalValidateApi
 * @extends {BaseAPI}
 */
export class ExternalValidateApi extends BaseAPI {
    /**
     * 
     * @param {string} key 
     * @param {string} email 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalValidateApi
     */
    public externalValidateValidateEmail(key: string, email: string, version: string, options?: any) {
        return ExternalValidateApiFp(this.configuration).externalValidateValidateEmail(key, email, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {string} mobilePhone 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalValidateApi
     */
    public externalValidateValidateMobilePhone(key: string, mobilePhone: string, version: string, options?: any) {
        return ExternalValidateApiFp(this.configuration).externalValidateValidateMobilePhone(key, mobilePhone, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {string} userName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalValidateApi
     */
    public externalValidateValidateUserName(key: string, userName: string, version: string, options?: any) {
        return ExternalValidateApiFp(this.configuration).externalValidateValidateUserName(key, userName, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FieldSalesLeadersApi - axios parameter creator
 * @export
 */
export const FieldSalesLeadersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldSalesLeadersGetAllAvailableFieldSalesLeaders: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fieldSalesLeadersGetAllAvailableFieldSalesLeaders.');
            }
            const localVarPath = `/api/v{version}/users/fieldsalesleaders`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FieldSalesLeadersApi - functional programming interface
 * @export
 */
export const FieldSalesLeadersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldSalesLeadersGetAllAvailableFieldSalesLeaders(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultFieldSalesLeader>> {
            const localVarAxiosArgs = await FieldSalesLeadersApiAxiosParamCreator(configuration).fieldSalesLeadersGetAllAvailableFieldSalesLeaders(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FieldSalesLeadersApi - factory interface
 * @export
 */
export const FieldSalesLeadersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldSalesLeadersGetAllAvailableFieldSalesLeaders(version: string, options?: any): AxiosPromise<PagedResultFieldSalesLeader> {
            return FieldSalesLeadersApiFp(configuration).fieldSalesLeadersGetAllAvailableFieldSalesLeaders(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FieldSalesLeadersApi - object-oriented interface
 * @export
 * @class FieldSalesLeadersApi
 * @extends {BaseAPI}
 */
export class FieldSalesLeadersApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldSalesLeadersApi
     */
    public fieldSalesLeadersGetAllAvailableFieldSalesLeaders(version: string, options?: any) {
        return FieldSalesLeadersApiFp(this.configuration).fieldSalesLeadersGetAllAvailableFieldSalesLeaders(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FieldVicePresidentApi - axios parameter creator
 * @export
 */
export const FieldVicePresidentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<FieldSalesLeaderDto>} fieldSalesLeaderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident: async (id: string, version: string, fieldSalesLeaderDto: Array<FieldSalesLeaderDto>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident.');
            }
            // verify required parameter 'fieldSalesLeaderDto' is not null or undefined
            if (fieldSalesLeaderDto === null || fieldSalesLeaderDto === undefined) {
                throw new RequiredError('fieldSalesLeaderDto','Required parameter fieldSalesLeaderDto was null or undefined when calling fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident.');
            }
            const localVarPath = `/api/v{version}/users/fieldvicepresident/{id}/fieldsalesleaders/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof fieldSalesLeaderDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(fieldSalesLeaderDto !== undefined ? fieldSalesLeaderDto : {}) : (fieldSalesLeaderDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FieldVicePresidentApi - functional programming interface
 * @export
 */
export const FieldVicePresidentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<FieldSalesLeaderDto>} fieldSalesLeaderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident(id: string, version: string, fieldSalesLeaderDto: Array<FieldSalesLeaderDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await FieldVicePresidentApiAxiosParamCreator(configuration).fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident(id, version, fieldSalesLeaderDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FieldVicePresidentApi - factory interface
 * @export
 */
export const FieldVicePresidentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<FieldSalesLeaderDto>} fieldSalesLeaderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident(id: string, version: string, fieldSalesLeaderDto: Array<FieldSalesLeaderDto>, options?: any): AxiosPromise<void> {
            return FieldVicePresidentApiFp(configuration).fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident(id, version, fieldSalesLeaderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FieldVicePresidentApi - object-oriented interface
 * @export
 * @class FieldVicePresidentApi
 * @extends {BaseAPI}
 */
export class FieldVicePresidentApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {Array<FieldSalesLeaderDto>} fieldSalesLeaderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldVicePresidentApi
     */
    public fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident(id: string, version: string, fieldSalesLeaderDto: Array<FieldSalesLeaderDto>, options?: any) {
        return FieldVicePresidentApiFp(this.configuration).fieldVicePresidentAssignFieldSalesLeadersToFieldVicePresident(id, version, fieldSalesLeaderDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [userUploadFileTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload: async (version: string, userUploadFileTypeId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileUpload.');
            }
            const localVarPath = `/api/v{version}/users/upload`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (userUploadFileTypeId !== undefined) {
                localVarQueryParameter['userUploadFileTypeId'] = userUploadFileTypeId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadEnrollTrack: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileUploadEnrollTrack.');
            }
            const localVarPath = `/api/v{version}/users/upload/enrolltrack`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadIndependent: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileUploadIndependent.');
            }
            const localVarPath = `/api/v{version}/users/upload/independent`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} isnewyork 
         * @param {string} [encryptedidentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadIndependentByAgency: async (version: string, isnewyork: string, encryptedidentifier?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling fileUploadIndependentByAgency.');
            }
            // verify required parameter 'isnewyork' is not null or undefined
            if (isnewyork === null || isnewyork === undefined) {
                throw new RequiredError('isnewyork','Required parameter isnewyork was null or undefined when calling fileUploadIndependentByAgency.');
            }
            const localVarPath = `/api/v{version}/users/upload/independent/agency/isnewyork/{isnewyork}`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)))
                .replace(`{${"isnewyork"}}`, encodeURIComponent(String(isnewyork)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (encryptedidentifier !== undefined) {
                localVarQueryParameter['encryptedidentifier'] = encryptedidentifier;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [userUploadFileTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUpload(version: string, userUploadFileTypeId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).fileUpload(version, userUploadFileTypeId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadEnrollTrack(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).fileUploadEnrollTrack(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadIndependent(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).fileUploadIndependent(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {string} isnewyork 
         * @param {string} [encryptedidentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadIndependentByAgency(version: string, isnewyork: string, encryptedidentifier?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await FileApiAxiosParamCreator(configuration).fileUploadIndependentByAgency(version, isnewyork, encryptedidentifier, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {number} [userUploadFileTypeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUpload(version: string, userUploadFileTypeId?: number, options?: any): AxiosPromise<any> {
            return FileApiFp(configuration).fileUpload(version, userUploadFileTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadEnrollTrack(version: string, options?: any): AxiosPromise<any> {
            return FileApiFp(configuration).fileUploadEnrollTrack(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadIndependent(version: string, options?: any): AxiosPromise<any> {
            return FileApiFp(configuration).fileUploadIndependent(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {string} isnewyork 
         * @param {string} [encryptedidentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadIndependentByAgency(version: string, isnewyork: string, encryptedidentifier?: string, options?: any): AxiosPromise<any> {
            return FileApiFp(configuration).fileUploadIndependentByAgency(version, isnewyork, encryptedidentifier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {number} [userUploadFileTypeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUpload(version: string, userUploadFileTypeId?: number, options?: any) {
        return FileApiFp(this.configuration).fileUpload(version, userUploadFileTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUploadEnrollTrack(version: string, options?: any) {
        return FileApiFp(this.configuration).fileUploadEnrollTrack(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUploadIndependent(version: string, options?: any) {
        return FileApiFp(this.configuration).fileUploadIndependent(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {string} isnewyork 
     * @param {string} [encryptedidentifier] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileUploadIndependentByAgency(version: string, isnewyork: string, encryptedidentifier?: string, options?: any) {
        return FileApiFp(this.configuration).fileUploadIndependentByAgency(version, isnewyork, encryptedidentifier, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * HeartbeatApi - axios parameter creator
 * @export
 */
export const HeartbeatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling heartbeatGet.');
            }
            const localVarPath = `/api/v{version}/users/heartbeat`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HeartbeatApi - functional programming interface
 * @export
 */
export const HeartbeatApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async heartbeatGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await HeartbeatApiAxiosParamCreator(configuration).heartbeatGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * HeartbeatApi - factory interface
 * @export
 */
export const HeartbeatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        heartbeatGet(version: string, options?: any): AxiosPromise<void> {
            return HeartbeatApiFp(configuration).heartbeatGet(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HeartbeatApi - object-oriented interface
 * @export
 * @class HeartbeatApi
 * @extends {BaseAPI}
 */
export class HeartbeatApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HeartbeatApi
     */
    public heartbeatGet(version: string, options?: any) {
        return HeartbeatApiFp(this.configuration).heartbeatGet(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * InternalValidateApi - axios parameter creator
 * @export
 */
export const InternalValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalValidateValidateEmail: async (email: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling internalValidateValidateEmail.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling internalValidateValidateEmail.');
            }
            const localVarPath = `/api/v{version}/users/internal/validate/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalValidateValidateMobilePhone: async (mobilePhone: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobilePhone' is not null or undefined
            if (mobilePhone === null || mobilePhone === undefined) {
                throw new RequiredError('mobilePhone','Required parameter mobilePhone was null or undefined when calling internalValidateValidateMobilePhone.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling internalValidateValidateMobilePhone.');
            }
            const localVarPath = `/api/v{version}/users/internal/validate/mobilephone/{mobilePhone}`
                .replace(`{${"mobilePhone"}}`, encodeURIComponent(String(mobilePhone)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalValidateValidateUserName: async (userName: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new RequiredError('userName','Required parameter userName was null or undefined when calling internalValidateValidateUserName.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling internalValidateValidateUserName.');
            }
            const localVarPath = `/api/v{version}/users/internal/validate/username/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalValidateApi - functional programming interface
 * @export
 */
export const InternalValidateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalValidateValidateEmail(email: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await InternalValidateApiAxiosParamCreator(configuration).internalValidateValidateEmail(email, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalValidateValidateMobilePhone(mobilePhone: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await InternalValidateApiAxiosParamCreator(configuration).internalValidateValidateMobilePhone(mobilePhone, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalValidateValidateUserName(userName: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await InternalValidateApiAxiosParamCreator(configuration).internalValidateValidateUserName(userName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * InternalValidateApi - factory interface
 * @export
 */
export const InternalValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalValidateValidateEmail(email: string, version: string, options?: any): AxiosPromise<void> {
            return InternalValidateApiFp(configuration).internalValidateValidateEmail(email, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalValidateValidateMobilePhone(mobilePhone: string, version: string, options?: any): AxiosPromise<void> {
            return InternalValidateApiFp(configuration).internalValidateValidateMobilePhone(mobilePhone, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalValidateValidateUserName(userName: string, version: string, options?: any): AxiosPromise<void> {
            return InternalValidateApiFp(configuration).internalValidateValidateUserName(userName, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalValidateApi - object-oriented interface
 * @export
 * @class InternalValidateApi
 * @extends {BaseAPI}
 */
export class InternalValidateApi extends BaseAPI {
    /**
     * 
     * @param {string} email 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalValidateApi
     */
    public internalValidateValidateEmail(email: string, version: string, options?: any) {
        return InternalValidateApiFp(this.configuration).internalValidateValidateEmail(email, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mobilePhone 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalValidateApi
     */
    public internalValidateValidateMobilePhone(mobilePhone: string, version: string, options?: any) {
        return InternalValidateApiFp(this.configuration).internalValidateValidateMobilePhone(mobilePhone, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalValidateApi
     */
    public internalValidateValidateUserName(userName: string, version: string, options?: any) {
        return InternalValidateApiFp(this.configuration).internalValidateValidateUserName(userName, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * LegalDocumentsApi - axios parameter creator
 * @export
 */
export const LegalDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legalDocumentsAccept: async (id: string, version: string, requestBody: Array<string>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling legalDocumentsAccept.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling legalDocumentsAccept.');
            }
            // verify required parameter 'requestBody' is not null or undefined
            if (requestBody === null || requestBody === undefined) {
                throw new RequiredError('requestBody','Required parameter requestBody was null or undefined when calling legalDocumentsAccept.');
            }
            const localVarPath = `/api/v{version}/users/{id}/legaldocuments/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof requestBody !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(requestBody !== undefined ? requestBody : {}) : (requestBody || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legalDocumentsGet: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling legalDocumentsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling legalDocumentsGet.');
            }
            const localVarPath = `/api/v{version}/users/legaldocuments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legalDocumentsGetAll: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling legalDocumentsGetAll.');
            }
            const localVarPath = `/api/v{version}/users/legaldocuments`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegalDocumentsApi - functional programming interface
 * @export
 */
export const LegalDocumentsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legalDocumentsAccept(id: string, version: string, requestBody: Array<string>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await LegalDocumentsApiAxiosParamCreator(configuration).legalDocumentsAccept(id, version, requestBody, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legalDocumentsGet(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalTextDto>> {
            const localVarAxiosArgs = await LegalDocumentsApiAxiosParamCreator(configuration).legalDocumentsGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async legalDocumentsGetAll(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LegalDocumentDto>>> {
            const localVarAxiosArgs = await LegalDocumentsApiAxiosParamCreator(configuration).legalDocumentsGetAll(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LegalDocumentsApi - factory interface
 * @export
 */
export const LegalDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legalDocumentsAccept(id: string, version: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return LegalDocumentsApiFp(configuration).legalDocumentsAccept(id, version, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legalDocumentsGet(id: string, version: string, options?: any): AxiosPromise<LegalTextDto> {
            return LegalDocumentsApiFp(configuration).legalDocumentsGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legalDocumentsGetAll(version: string, options?: any): AxiosPromise<Array<LegalDocumentDto>> {
            return LegalDocumentsApiFp(configuration).legalDocumentsGetAll(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegalDocumentsApi - object-oriented interface
 * @export
 * @class LegalDocumentsApi
 * @extends {BaseAPI}
 */
export class LegalDocumentsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApi
     */
    public legalDocumentsAccept(id: string, version: string, requestBody: Array<string>, options?: any) {
        return LegalDocumentsApiFp(this.configuration).legalDocumentsAccept(id, version, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApi
     */
    public legalDocumentsGet(id: string, version: string, options?: any) {
        return LegalDocumentsApiFp(this.configuration).legalDocumentsGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApi
     */
    public legalDocumentsGetAll(version: string, options?: any) {
        return LegalDocumentsApiFp(this.configuration).legalDocumentsGetAll(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * PreregisterUserApi - axios parameter creator
 * @export
 */
export const PreregisterUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserDelete: async (id: string, version: string, applicationIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling preregisterUserDelete.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling preregisterUserDelete.');
            }
            const localVarPath = `/api/v{version}/users/preregister/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (applicationIds) {
                localVarQueryParameter['applicationIds'] = applicationIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling preregisterUserGet.');
            }
            const localVarPath = `/api/v{version}/users/preregister`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserGetByKey: async (key: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling preregisterUserGetByKey.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling preregisterUserGetByKey.');
            }
            const localVarPath = `/api/v{version}/users/preregister/key/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {LinkPreregisteredUserCommand} linkPreregisteredUserCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserLink: async (version: string, linkPreregisteredUserCommand: LinkPreregisteredUserCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling preregisterUserLink.');
            }
            // verify required parameter 'linkPreregisteredUserCommand' is not null or undefined
            if (linkPreregisteredUserCommand === null || linkPreregisteredUserCommand === undefined) {
                throw new RequiredError('linkPreregisteredUserCommand','Required parameter linkPreregisteredUserCommand was null or undefined when calling preregisterUserLink.');
            }
            const localVarPath = `/api/v{version}/users/preregister/link`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof linkPreregisteredUserCommand !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(linkPreregisteredUserCommand !== undefined ? linkPreregisteredUserCommand : {}) : (linkPreregisteredUserCommand || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserResendRegistraionEmail: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling preregisterUserResendRegistraionEmail.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling preregisterUserResendRegistraionEmail.');
            }
            const localVarPath = `/api/v{version}/users/preregister/{id}/resendemail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreregisterUserApi - functional programming interface
 * @export
 */
export const PreregisterUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preregisterUserDelete(id: string, version: string, applicationIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await PreregisterUserApiAxiosParamCreator(configuration).preregisterUserDelete(id, version, applicationIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preregisterUserGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultPreregisteredUserDto>> {
            const localVarAxiosArgs = await PreregisterUserApiAxiosParamCreator(configuration).preregisterUserGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preregisterUserGetByKey(key: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreregisteredUserDetailDto>> {
            const localVarAxiosArgs = await PreregisterUserApiAxiosParamCreator(configuration).preregisterUserGetByKey(key, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {LinkPreregisteredUserCommand} linkPreregisteredUserCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preregisterUserLink(version: string, linkPreregisteredUserCommand: LinkPreregisteredUserCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PreregisterUserApiAxiosParamCreator(configuration).preregisterUserLink(version, linkPreregisteredUserCommand, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async preregisterUserResendRegistraionEmail(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PreregisterUserApiAxiosParamCreator(configuration).preregisterUserResendRegistraionEmail(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PreregisterUserApi - factory interface
 * @export
 */
export const PreregisterUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserDelete(id: string, version: string, applicationIds?: Array<number>, options?: any): AxiosPromise<any> {
            return PreregisterUserApiFp(configuration).preregisterUserDelete(id, version, applicationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserGet(version: string, options?: any): AxiosPromise<PagedResultPreregisteredUserDto> {
            return PreregisterUserApiFp(configuration).preregisterUserGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserGetByKey(key: string, version: string, options?: any): AxiosPromise<PreregisteredUserDetailDto> {
            return PreregisterUserApiFp(configuration).preregisterUserGetByKey(key, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {LinkPreregisteredUserCommand} linkPreregisteredUserCommand 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserLink(version: string, linkPreregisteredUserCommand: LinkPreregisteredUserCommand, options?: any): AxiosPromise<void> {
            return PreregisterUserApiFp(configuration).preregisterUserLink(version, linkPreregisteredUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preregisterUserResendRegistraionEmail(id: string, version: string, options?: any): AxiosPromise<void> {
            return PreregisterUserApiFp(configuration).preregisterUserResendRegistraionEmail(id, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreregisterUserApi - object-oriented interface
 * @export
 * @class PreregisterUserApi
 * @extends {BaseAPI}
 */
export class PreregisterUserApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {Array<number>} [applicationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreregisterUserApi
     */
    public preregisterUserDelete(id: string, version: string, applicationIds?: Array<number>, options?: any) {
        return PreregisterUserApiFp(this.configuration).preregisterUserDelete(id, version, applicationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreregisterUserApi
     */
    public preregisterUserGet(version: string, options?: any) {
        return PreregisterUserApiFp(this.configuration).preregisterUserGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreregisterUserApi
     */
    public preregisterUserGetByKey(key: string, version: string, options?: any) {
        return PreregisterUserApiFp(this.configuration).preregisterUserGetByKey(key, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {LinkPreregisteredUserCommand} linkPreregisteredUserCommand 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreregisterUserApi
     */
    public preregisterUserLink(version: string, linkPreregisteredUserCommand: LinkPreregisteredUserCommand, options?: any) {
        return PreregisterUserApiFp(this.configuration).preregisterUserLink(version, linkPreregisteredUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreregisterUserApi
     */
    public preregisterUserResendRegistraionEmail(id: string, version: string, options?: any) {
        return PreregisterUserApiFp(this.configuration).preregisterUserResendRegistraionEmail(id, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProcessLogsApi - axios parameter creator
 * @export
 */
export const ProcessLogsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling getLatestEtlStatuses.');
            }
            const localVarPath = `/api/v{version}/users/processlogs/latest`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessLogsApi - functional programming interface
 * @export
 */
export const ProcessLogsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestEtlStatuses(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessLogDto>>> {
            const localVarAxiosArgs = await ProcessLogsApiAxiosParamCreator(configuration).getLatestEtlStatuses(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProcessLogsApi - factory interface
 * @export
 */
export const ProcessLogsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestEtlStatuses(version: string, options?: any): AxiosPromise<Array<ProcessLogDto>> {
            return ProcessLogsApiFp(configuration).getLatestEtlStatuses(version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessLogsApi - object-oriented interface
 * @export
 * @class ProcessLogsApi
 * @extends {BaseAPI}
 */
export class ProcessLogsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcessLogsApi
     */
    public getLatestEtlStatuses(version: string, options?: any) {
        return ProcessLogsApiFp(this.configuration).getLatestEtlStatuses(version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileGet: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling profileGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling profileGet.');
            }
            const localVarPath = `/api/v{version}/users/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileUpdateBySecurityQuestions: async (id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling profileUpdateBySecurityQuestions.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling profileUpdateBySecurityQuestions.');
            }
            // verify required parameter 'passwordUpdateBySecurityQuestionRequestDto' is not null or undefined
            if (passwordUpdateBySecurityQuestionRequestDto === null || passwordUpdateBySecurityQuestionRequestDto === undefined) {
                throw new RequiredError('passwordUpdateBySecurityQuestionRequestDto','Required parameter passwordUpdateBySecurityQuestionRequestDto was null or undefined when calling profileUpdateBySecurityQuestions.');
            }
            const localVarPath = `/api/v{version}/users/profile/{id}/password/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordUpdateBySecurityQuestionRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordUpdateBySecurityQuestionRequestDto !== undefined ? passwordUpdateBySecurityQuestionRequestDto : {}) : (passwordUpdateBySecurityQuestionRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileGet(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
            const localVarAxiosArgs = await ProfileApiAxiosParamCreator(configuration).profileGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileUpdateBySecurityQuestions(id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ProfileApiAxiosParamCreator(configuration).profileUpdateBySecurityQuestions(id, version, passwordUpdateBySecurityQuestionRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileGet(id: string, version: string, options?: any): AxiosPromise<UserProfile> {
            return ProfileApiFp(configuration).profileGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileUpdateBySecurityQuestions(id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options?: any): AxiosPromise<void> {
            return ProfileApiFp(configuration).profileUpdateBySecurityQuestions(id, version, passwordUpdateBySecurityQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileGet(id: string, version: string, options?: any) {
        return ProfileApiFp(this.configuration).profileGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public profileUpdateBySecurityQuestions(id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options?: any) {
        return ProfileApiFp(this.configuration).profileUpdateBySecurityQuestions(id, version, passwordUpdateBySecurityQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RecruiterCodeApi - axios parameter creator
 * @export
 */
export const RecruiterCodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} recruitercode 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruiterCodeSearch: async (recruitercode: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'recruitercode' is not null or undefined
            if (recruitercode === null || recruitercode === undefined) {
                throw new RequiredError('recruitercode','Required parameter recruitercode was null or undefined when calling recruiterCodeSearch.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling recruiterCodeSearch.');
            }
            const localVarPath = `/api/v{version}/users/recruitercodes/{recruitercode}`
                .replace(`{${"recruitercode"}}`, encodeURIComponent(String(recruitercode)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecruiterCodeApi - functional programming interface
 * @export
 */
export const RecruiterCodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} recruitercode 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recruiterCodeSearch(recruitercode: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecruiterCodeDto>>> {
            const localVarAxiosArgs = await RecruiterCodeApiAxiosParamCreator(configuration).recruiterCodeSearch(recruitercode, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RecruiterCodeApi - factory interface
 * @export
 */
export const RecruiterCodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} recruitercode 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recruiterCodeSearch(recruitercode: string, version: string, options?: any): AxiosPromise<Array<RecruiterCodeDto>> {
            return RecruiterCodeApiFp(configuration).recruiterCodeSearch(recruitercode, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecruiterCodeApi - object-oriented interface
 * @export
 * @class RecruiterCodeApi
 * @extends {BaseAPI}
 */
export class RecruiterCodeApi extends BaseAPI {
    /**
     * 
     * @param {string} recruitercode 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecruiterCodeApi
     */
    public recruiterCodeSearch(recruitercode: string, version: string, options?: any) {
        return RecruiterCodeApiFp(this.configuration).recruiterCodeSearch(recruitercode, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [roleType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesGet: async (version: string, roleType?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling rolesGet.');
            }
            const localVarPath = `/api/v{version}/users/roles`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (roleType !== undefined) {
                localVarQueryParameter['roleType'] = roleType;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [roleType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesGet(version: string, roleType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleBase>>> {
            const localVarAxiosArgs = await RolesApiAxiosParamCreator(configuration).rolesGet(version, roleType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {string} [roleType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesGet(version: string, roleType?: string, options?: any): AxiosPromise<Array<RoleBase>> {
            return RolesApiFp(configuration).rolesGet(version, roleType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {string} [roleType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public rolesGet(version: string, roleType?: string, options?: any) {
        return RolesApiFp(this.configuration).rolesGet(version, roleType, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * SsoApi - axios parameter creator
 * @export
 */
export const SsoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoAccount: async (id: string, version: string, username?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoAccount.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoAccount.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoAccounts: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoAccounts.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoAccounts.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SsoInsertDto} ssoInsertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoInsert: async (id: string, version: string, ssoInsertDto: SsoInsertDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoInsert.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoInsert.');
            }
            // verify required parameter 'ssoInsertDto' is not null or undefined
            if (ssoInsertDto === null || ssoInsertDto === undefined) {
                throw new RequiredError('ssoInsertDto','Required parameter ssoInsertDto was null or undefined when calling ssoSsoInsert.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso/add`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ssoInsertDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ssoInsertDto !== undefined ? ssoInsertDto : {}) : (ssoInsertDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [nyaccess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoLegacyBulletins: async (id: string, version: string, nyaccess?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoLegacyBulletins.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoLegacyBulletins.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso/bulletins`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (nyaccess !== undefined) {
                localVarQueryParameter['nyaccess'] = nyaccess;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [nyaccess] 
         * @param {boolean} [interactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoLegacyForms: async (id: string, version: string, nyaccess?: boolean, interactive?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoLegacyForms.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoLegacyForms.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso/forms`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (nyaccess !== undefined) {
                localVarQueryParameter['nyaccess'] = nyaccess;
            }

            if (interactive !== undefined) {
                localVarQueryParameter['interactive'] = interactive;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoRemove: async (id: string, version: string, username?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoRemove.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoRemove.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} ssoEntityId 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoRequest: async (id: string, ssoEntityId: number, version: string, username?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoRequest.');
            }
            // verify required parameter 'ssoEntityId' is not null or undefined
            if (ssoEntityId === null || ssoEntityId === undefined) {
                throw new RequiredError('ssoEntityId','Required parameter ssoEntityId was null or undefined when calling ssoSsoRequest.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoRequest.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso/{ssoEntityId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"ssoEntityId"}}`, encodeURIComponent(String(ssoEntityId)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SsoUpdateDto} ssoUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoUserUpdate: async (id: string, version: string, ssoUpdateDto: SsoUpdateDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling ssoSsoUserUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling ssoSsoUserUpdate.');
            }
            // verify required parameter 'ssoUpdateDto' is not null or undefined
            if (ssoUpdateDto === null || ssoUpdateDto === undefined) {
                throw new RequiredError('ssoUpdateDto','Required parameter ssoUpdateDto was null or undefined when calling ssoSsoUserUpdate.');
            }
            const localVarPath = `/api/v{version}/users/{id}/sso`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof ssoUpdateDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(ssoUpdateDto !== undefined ? ssoUpdateDto : {}) : (ssoUpdateDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SsoApi - functional programming interface
 * @export
 */
export const SsoApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoAccount(id: string, version: string, username?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoAccountDto>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoAccount(id, version, username, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoAccounts(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SsoAccountDto>>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoAccounts(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SsoInsertDto} ssoInsertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoInsert(id: string, version: string, ssoInsertDto: SsoInsertDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoInsert(id, version, ssoInsertDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [nyaccess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoLegacyBulletins(id: string, version: string, nyaccess?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoResponseDto>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoLegacyBulletins(id, version, nyaccess, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [nyaccess] 
         * @param {boolean} [interactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoLegacyForms(id: string, version: string, nyaccess?: boolean, interactive?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoResponseDto>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoLegacyForms(id, version, nyaccess, interactive, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoRemove(id: string, version: string, username?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoRemove(id, version, username, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {number} ssoEntityId 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoRequest(id: string, ssoEntityId: number, version: string, username?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SsoResponseDto>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoRequest(id, ssoEntityId, version, username, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SsoUpdateDto} ssoUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ssoSsoUserUpdate(id: string, version: string, ssoUpdateDto: SsoUpdateDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await SsoApiAxiosParamCreator(configuration).ssoSsoUserUpdate(id, version, ssoUpdateDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * SsoApi - factory interface
 * @export
 */
export const SsoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoAccount(id: string, version: string, username?: string, options?: any): AxiosPromise<SsoAccountDto> {
            return SsoApiFp(configuration).ssoSsoAccount(id, version, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoAccounts(id: string, version: string, options?: any): AxiosPromise<Array<SsoAccountDto>> {
            return SsoApiFp(configuration).ssoSsoAccounts(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SsoInsertDto} ssoInsertDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoInsert(id: string, version: string, ssoInsertDto: SsoInsertDto, options?: any): AxiosPromise<void> {
            return SsoApiFp(configuration).ssoSsoInsert(id, version, ssoInsertDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [nyaccess] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoLegacyBulletins(id: string, version: string, nyaccess?: boolean, options?: any): AxiosPromise<SsoResponseDto> {
            return SsoApiFp(configuration).ssoSsoLegacyBulletins(id, version, nyaccess, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {boolean} [nyaccess] 
         * @param {boolean} [interactive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoLegacyForms(id: string, version: string, nyaccess?: boolean, interactive?: boolean, options?: any): AxiosPromise<SsoResponseDto> {
            return SsoApiFp(configuration).ssoSsoLegacyForms(id, version, nyaccess, interactive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoRemove(id: string, version: string, username?: string, options?: any): AxiosPromise<void> {
            return SsoApiFp(configuration).ssoSsoRemove(id, version, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {number} ssoEntityId 
         * @param {string} version 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoRequest(id: string, ssoEntityId: number, version: string, username?: string, options?: any): AxiosPromise<SsoResponseDto> {
            return SsoApiFp(configuration).ssoSsoRequest(id, ssoEntityId, version, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {SsoUpdateDto} ssoUpdateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ssoSsoUserUpdate(id: string, version: string, ssoUpdateDto: SsoUpdateDto, options?: any): AxiosPromise<void> {
            return SsoApiFp(configuration).ssoSsoUserUpdate(id, version, ssoUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SsoApi - object-oriented interface
 * @export
 * @class SsoApi
 * @extends {BaseAPI}
 */
export class SsoApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoAccount(id: string, version: string, username?: string, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoAccount(id, version, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoAccounts(id: string, version: string, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoAccounts(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {SsoInsertDto} ssoInsertDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoInsert(id: string, version: string, ssoInsertDto: SsoInsertDto, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoInsert(id, version, ssoInsertDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {boolean} [nyaccess] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoLegacyBulletins(id: string, version: string, nyaccess?: boolean, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoLegacyBulletins(id, version, nyaccess, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {boolean} [nyaccess] 
     * @param {boolean} [interactive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoLegacyForms(id: string, version: string, nyaccess?: boolean, interactive?: boolean, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoLegacyForms(id, version, nyaccess, interactive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoRemove(id: string, version: string, username?: string, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoRemove(id, version, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {number} ssoEntityId 
     * @param {string} version 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoRequest(id: string, ssoEntityId: number, version: string, username?: string, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoRequest(id, ssoEntityId, version, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {SsoUpdateDto} ssoUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsoApi
     */
    public ssoSsoUserUpdate(id: string, version: string, ssoUpdateDto: SsoUpdateDto, options?: any) {
        return SsoApiFp(this.configuration).ssoSsoUserUpdate(id, version, ssoUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling searchUsers.');
            }
            const localVarPath = `/api/v{version}/users`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {boolean} [isNewYork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultAgencyAssociation: async (id: string, version: string, encryptedIdentifier?: string, isNewYork?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateDefaultAgencyAssociation.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateDefaultAgencyAssociation.');
            }
            const localVarPath = `/api/v{version}/users/{id}/defaultagencyassociation/update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (encryptedIdentifier !== undefined) {
                localVarQueryParameter['encryptedIdentifier'] = encryptedIdentifier;
            }

            if (isNewYork !== undefined) {
                localVarQueryParameter['isNewYork'] = isNewYork;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDelete: async (id: string, version: string, applicationIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userDelete.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userDelete.');
            }
            const localVarPath = `/api/v{version}/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (applicationIds) {
                localVarQueryParameter['applicationIds'] = applicationIds;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} impersonatedUsername 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImpersonate: async (username: string, impersonatedUsername: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling userImpersonate.');
            }
            // verify required parameter 'impersonatedUsername' is not null or undefined
            if (impersonatedUsername === null || impersonatedUsername === undefined) {
                throw new RequiredError('impersonatedUsername','Required parameter impersonatedUsername was null or undefined when calling userImpersonate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userImpersonate.');
            }
            const localVarPath = `/api/v{version}/users/{username}/impersonate/{impersonatedUsername}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)))
                .replace(`{${"impersonatedUsername"}}`, encodeURIComponent(String(impersonatedUsername)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userResetPassword: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userResetPassword.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userResetPassword.');
            }
            const localVarPath = `/api/v{version}/users/{id}/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userStopImpersonation: async (username: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling userStopImpersonation.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userStopImpersonation.');
            }
            const localVarPath = `/api/v{version}/users/{username}/impersonate/stop`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UnlockAccountBySecurityQuestionsRequestDto} unlockAccountBySecurityQuestionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUnlock: async (id: string, version: string, unlockAccountBySecurityQuestionsRequestDto: UnlockAccountBySecurityQuestionsRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userUnlock.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userUnlock.');
            }
            // verify required parameter 'unlockAccountBySecurityQuestionsRequestDto' is not null or undefined
            if (unlockAccountBySecurityQuestionsRequestDto === null || unlockAccountBySecurityQuestionsRequestDto === undefined) {
                throw new RequiredError('unlockAccountBySecurityQuestionsRequestDto','Required parameter unlockAccountBySecurityQuestionsRequestDto was null or undefined when calling userUnlock.');
            }
            const localVarPath = `/api/v{version}/users/{id}/unlock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof unlockAccountBySecurityQuestionsRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(unlockAccountBySecurityQuestionsRequestDto !== undefined ? unlockAccountBySecurityQuestionsRequestDto : {}) : (unlockAccountBySecurityQuestionsRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {NameUpdateRequestDto} nameUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdate: async (id: string, version: string, nameUpdateRequestDto: NameUpdateRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userUpdate.');
            }
            // verify required parameter 'nameUpdateRequestDto' is not null or undefined
            if (nameUpdateRequestDto === null || nameUpdateRequestDto === undefined) {
                throw new RequiredError('nameUpdateRequestDto','Required parameter nameUpdateRequestDto was null or undefined when calling userUpdate.');
            }
            const localVarPath = `/api/v{version}/users/{id}/name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof nameUpdateRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(nameUpdateRequestDto !== undefined ? nameUpdateRequestDto : {}) : (nameUpdateRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResultOfUserDto>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).searchUsers(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {boolean} [isNewYork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultAgencyAssociation(id: string, version: string, encryptedIdentifier?: string, isNewYork?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).updateDefaultAgencyAssociation(id, version, encryptedIdentifier, isNewYork, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDelete(id: string, version: string, applicationIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userDelete(id, version, applicationIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} impersonatedUsername 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userImpersonate(username: string, impersonatedUsername: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userImpersonate(username, impersonatedUsername, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userResetPassword(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userResetPassword(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userStopImpersonation(username: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userStopImpersonation(username, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UnlockAccountBySecurityQuestionsRequestDto} unlockAccountBySecurityQuestionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userUnlock(id: string, version: string, unlockAccountBySecurityQuestionsRequestDto: UnlockAccountBySecurityQuestionsRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userUnlock(id, version, unlockAccountBySecurityQuestionsRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {NameUpdateRequestDto} nameUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userUpdate(id: string, version: string, nameUpdateRequestDto: NameUpdateRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserApiAxiosParamCreator(configuration).userUpdate(id, version, nameUpdateRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(version: string, options?: any): AxiosPromise<PagedResultOfUserDto> {
            return UserApiFp(configuration).searchUsers(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {boolean} [isNewYork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultAgencyAssociation(id: string, version: string, encryptedIdentifier?: string, isNewYork?: boolean, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).updateDefaultAgencyAssociation(id, version, encryptedIdentifier, isNewYork, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDelete(id: string, version: string, applicationIds?: Array<number>, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userDelete(id, version, applicationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} impersonatedUsername 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userImpersonate(username: string, impersonatedUsername: string, version: string, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userImpersonate(username, impersonatedUsername, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userResetPassword(id: string, version: string, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userResetPassword(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userStopImpersonation(username: string, version: string, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userStopImpersonation(username, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UnlockAccountBySecurityQuestionsRequestDto} unlockAccountBySecurityQuestionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUnlock(id: string, version: string, unlockAccountBySecurityQuestionsRequestDto: UnlockAccountBySecurityQuestionsRequestDto, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userUnlock(id, version, unlockAccountBySecurityQuestionsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {NameUpdateRequestDto} nameUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdate(id: string, version: string, nameUpdateRequestDto: NameUpdateRequestDto, options?: any): AxiosPromise<void> {
            return UserApiFp(configuration).userUpdate(id, version, nameUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public searchUsers(version: string, options?: any) {
        return UserApiFp(this.configuration).searchUsers(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {string} [encryptedIdentifier] 
     * @param {boolean} [isNewYork] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateDefaultAgencyAssociation(id: string, version: string, encryptedIdentifier?: string, isNewYork?: boolean, options?: any) {
        return UserApiFp(this.configuration).updateDefaultAgencyAssociation(id, version, encryptedIdentifier, isNewYork, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {Array<number>} [applicationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userDelete(id: string, version: string, applicationIds?: Array<number>, options?: any) {
        return UserApiFp(this.configuration).userDelete(id, version, applicationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} impersonatedUsername 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userImpersonate(username: string, impersonatedUsername: string, version: string, options?: any) {
        return UserApiFp(this.configuration).userImpersonate(username, impersonatedUsername, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userResetPassword(id: string, version: string, options?: any) {
        return UserApiFp(this.configuration).userResetPassword(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userStopImpersonation(username: string, version: string, options?: any) {
        return UserApiFp(this.configuration).userStopImpersonation(username, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {UnlockAccountBySecurityQuestionsRequestDto} unlockAccountBySecurityQuestionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userUnlock(id: string, version: string, unlockAccountBySecurityQuestionsRequestDto: UnlockAccountBySecurityQuestionsRequestDto, options?: any) {
        return UserApiFp(this.configuration).userUnlock(id, version, unlockAccountBySecurityQuestionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {NameUpdateRequestDto} nameUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userUpdate(id: string, version: string, nameUpdateRequestDto: NameUpdateRequestDto, options?: any) {
        return UserApiFp(this.configuration).userUpdate(id, version, nameUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserAdministrationApi - axios parameter creator
 * @export
 */
export const UserAdministrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {UserEntryDto} userEntryDto 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser: async (version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling addUser.');
            }
            // verify required parameter 'userEntryDto' is not null or undefined
            if (userEntryDto === null || userEntryDto === undefined) {
                throw new RequiredError('userEntryDto','Required parameter userEntryDto was null or undefined when calling addUser.');
            }
            const localVarPath = `/api/v{version}/users/administration`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (applicationIds) {
                localVarQueryParameter['applicationIds'] = applicationIds;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userEntryDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userEntryDto !== undefined ? userEntryDto : {}) : (userEntryDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UserEntryDto} userEntryDto 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling updateUser.');
            }
            // verify required parameter 'userEntryDto' is not null or undefined
            if (userEntryDto === null || userEntryDto === undefined) {
                throw new RequiredError('userEntryDto','Required parameter userEntryDto was null or undefined when calling updateUser.');
            }
            const localVarPath = `/api/v{version}/users/administration`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (applicationIds) {
                localVarQueryParameter['applicationIds'] = applicationIds;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof userEntryDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(userEntryDto !== undefined ? userEntryDto : {}) : (userEntryDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserAdministrationApi - functional programming interface
 * @export
 */
export const UserAdministrationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {UserEntryDto} userEntryDto 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUser(version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await UserAdministrationApiAxiosParamCreator(configuration).addUser(version, userEntryDto, applicationIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} version 
         * @param {UserEntryDto} userEntryDto 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await UserAdministrationApiAxiosParamCreator(configuration).updateUser(version, userEntryDto, applicationIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserAdministrationApi - factory interface
 * @export
 */
export const UserAdministrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {UserEntryDto} userEntryDto 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser(version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options?: any): AxiosPromise<number> {
            return UserAdministrationApiFp(configuration).addUser(version, userEntryDto, applicationIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} version 
         * @param {UserEntryDto} userEntryDto 
         * @param {Array<number>} [applicationIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options?: any): AxiosPromise<number> {
            return UserAdministrationApiFp(configuration).updateUser(version, userEntryDto, applicationIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserAdministrationApi - object-oriented interface
 * @export
 * @class UserAdministrationApi
 * @extends {BaseAPI}
 */
export class UserAdministrationApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {UserEntryDto} userEntryDto 
     * @param {Array<number>} [applicationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdministrationApi
     */
    public addUser(version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options?: any) {
        return UserAdministrationApiFp(this.configuration).addUser(version, userEntryDto, applicationIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} version 
     * @param {UserEntryDto} userEntryDto 
     * @param {Array<number>} [applicationIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserAdministrationApi
     */
    public updateUser(version: string, userEntryDto: UserEntryDto, applicationIds?: Array<number>, options?: any) {
        return UserAdministrationApiFp(this.configuration).updateUser(version, userEntryDto, applicationIds, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserDetailsApi - axios parameter creator
 * @export
 */
export const UserDetailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetailsGet: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userDetailsGet.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userDetailsGet.');
            }
            const localVarPath = `/api/v{version}/users/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetailsGetAgent: async (id: string, version: string, encryptedIdentifier?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userDetailsGetAgent.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userDetailsGetAgent.');
            }
            const localVarPath = `/api/v{version}/users/agents/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (encryptedIdentifier !== undefined) {
                localVarQueryParameter['encryptedIdentifier'] = encryptedIdentifier;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetailsGetPreregisteredUser: async (id: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userDetailsGetPreregisteredUser.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userDetailsGetPreregisteredUser.');
            }
            const localVarPath = `/api/v{version}/users/preregistereduser/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserDetailsApi - functional programming interface
 * @export
 */
export const UserDetailsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDetailsGet(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await UserDetailsApiAxiosParamCreator(configuration).userDetailsGet(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDetailsGetAgent(id: string, version: string, encryptedIdentifier?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentUserDetailDto>> {
            const localVarAxiosArgs = await UserDetailsApiAxiosParamCreator(configuration).userDetailsGetAgent(id, version, encryptedIdentifier, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDetailsGetPreregisteredUser(id: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreregisteredAgentDetailDto>> {
            const localVarAxiosArgs = await UserDetailsApiAxiosParamCreator(configuration).userDetailsGetPreregisteredUser(id, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserDetailsApi - factory interface
 * @export
 */
export const UserDetailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetailsGet(id: string, version: string, options?: any): AxiosPromise<UserDetailDto> {
            return UserDetailsApiFp(configuration).userDetailsGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {string} [encryptedIdentifier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetailsGetAgent(id: string, version: string, encryptedIdentifier?: string, options?: any): AxiosPromise<AgentUserDetailDto> {
            return UserDetailsApiFp(configuration).userDetailsGetAgent(id, version, encryptedIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDetailsGetPreregisteredUser(id: string, version: string, options?: any): AxiosPromise<PreregisteredAgentDetailDto> {
            return UserDetailsApiFp(configuration).userDetailsGetPreregisteredUser(id, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserDetailsApi - object-oriented interface
 * @export
 * @class UserDetailsApi
 * @extends {BaseAPI}
 */
export class UserDetailsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDetailsApi
     */
    public userDetailsGet(id: string, version: string, options?: any) {
        return UserDetailsApiFp(this.configuration).userDetailsGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {string} [encryptedIdentifier] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDetailsApi
     */
    public userDetailsGetAgent(id: string, version: string, encryptedIdentifier?: string, options?: any) {
        return UserDetailsApiFp(this.configuration).userDetailsGetAgent(id, version, encryptedIdentifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserDetailsApi
     */
    public userDetailsGetPreregisteredUser(id: string, version: string, options?: any) {
        return UserDetailsApiFp(this.configuration).userDetailsGetPreregisteredUser(id, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserEmailApi - axios parameter creator
 * @export
 */
export const UserEmailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {EmailUpdateRequestDto} emailUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailUpdate: async (id: string, version: string, emailUpdateRequestDto: EmailUpdateRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userEmailUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userEmailUpdate.');
            }
            // verify required parameter 'emailUpdateRequestDto' is not null or undefined
            if (emailUpdateRequestDto === null || emailUpdateRequestDto === undefined) {
                throw new RequiredError('emailUpdateRequestDto','Required parameter emailUpdateRequestDto was null or undefined when calling userEmailUpdate.');
            }
            const localVarPath = `/api/v{version}/users/{id}/email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof emailUpdateRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(emailUpdateRequestDto !== undefined ? emailUpdateRequestDto : {}) : (emailUpdateRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailValidate: async (email: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling userEmailValidate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userEmailValidate.');
            }
            const localVarPath = `/api/v{version}/users/email/validate/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserEmailApi - functional programming interface
 * @export
 */
export const UserEmailApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {EmailUpdateRequestDto} emailUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userEmailUpdate(id: string, version: string, emailUpdateRequestDto: EmailUpdateRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserEmailApiAxiosParamCreator(configuration).userEmailUpdate(id, version, emailUpdateRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userEmailValidate(email: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserEmailApiAxiosParamCreator(configuration).userEmailValidate(email, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserEmailApi - factory interface
 * @export
 */
export const UserEmailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {EmailUpdateRequestDto} emailUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailUpdate(id: string, version: string, emailUpdateRequestDto: EmailUpdateRequestDto, options?: any): AxiosPromise<void> {
            return UserEmailApiFp(configuration).userEmailUpdate(id, version, emailUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEmailValidate(email: string, version: string, options?: any): AxiosPromise<void> {
            return UserEmailApiFp(configuration).userEmailValidate(email, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserEmailApi - object-oriented interface
 * @export
 * @class UserEmailApi
 * @extends {BaseAPI}
 */
export class UserEmailApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {EmailUpdateRequestDto} emailUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserEmailApi
     */
    public userEmailUpdate(id: string, version: string, emailUpdateRequestDto: EmailUpdateRequestDto, options?: any) {
        return UserEmailApiFp(this.configuration).userEmailUpdate(id, version, emailUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserEmailApi
     */
    public userEmailValidate(email: string, version: string, options?: any) {
        return UserEmailApiFp(this.configuration).userEmailValidate(email, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserMobilePhoneApi - axios parameter creator
 * @export
 */
export const UserMobilePhoneApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {MobilePhoneUpdateRequestDto} mobilePhoneUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMobilePhoneUpdate: async (id: string, version: string, mobilePhoneUpdateRequestDto: MobilePhoneUpdateRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userMobilePhoneUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userMobilePhoneUpdate.');
            }
            // verify required parameter 'mobilePhoneUpdateRequestDto' is not null or undefined
            if (mobilePhoneUpdateRequestDto === null || mobilePhoneUpdateRequestDto === undefined) {
                throw new RequiredError('mobilePhoneUpdateRequestDto','Required parameter mobilePhoneUpdateRequestDto was null or undefined when calling userMobilePhoneUpdate.');
            }
            const localVarPath = `/api/v{version}/users/{id}/mobilePhone`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof mobilePhoneUpdateRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(mobilePhoneUpdateRequestDto !== undefined ? mobilePhoneUpdateRequestDto : {}) : (mobilePhoneUpdateRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMobilePhoneValidate: async (mobilePhone: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobilePhone' is not null or undefined
            if (mobilePhone === null || mobilePhone === undefined) {
                throw new RequiredError('mobilePhone','Required parameter mobilePhone was null or undefined when calling userMobilePhoneValidate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userMobilePhoneValidate.');
            }
            const localVarPath = `/api/v{version}/users/mobilePhone/validate/{mobilePhone}`
                .replace(`{${"mobilePhone"}}`, encodeURIComponent(String(mobilePhone)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserMobilePhoneApi - functional programming interface
 * @export
 */
export const UserMobilePhoneApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {MobilePhoneUpdateRequestDto} mobilePhoneUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userMobilePhoneUpdate(id: string, version: string, mobilePhoneUpdateRequestDto: MobilePhoneUpdateRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserMobilePhoneApiAxiosParamCreator(configuration).userMobilePhoneUpdate(id, version, mobilePhoneUpdateRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userMobilePhoneValidate(mobilePhone: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserMobilePhoneApiAxiosParamCreator(configuration).userMobilePhoneValidate(mobilePhone, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserMobilePhoneApi - factory interface
 * @export
 */
export const UserMobilePhoneApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {MobilePhoneUpdateRequestDto} mobilePhoneUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMobilePhoneUpdate(id: string, version: string, mobilePhoneUpdateRequestDto: MobilePhoneUpdateRequestDto, options?: any): AxiosPromise<void> {
            return UserMobilePhoneApiFp(configuration).userMobilePhoneUpdate(id, version, mobilePhoneUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} mobilePhone 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMobilePhoneValidate(mobilePhone: string, version: string, options?: any): AxiosPromise<void> {
            return UserMobilePhoneApiFp(configuration).userMobilePhoneValidate(mobilePhone, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserMobilePhoneApi - object-oriented interface
 * @export
 * @class UserMobilePhoneApi
 * @extends {BaseAPI}
 */
export class UserMobilePhoneApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {MobilePhoneUpdateRequestDto} mobilePhoneUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMobilePhoneApi
     */
    public userMobilePhoneUpdate(id: string, version: string, mobilePhoneUpdateRequestDto: MobilePhoneUpdateRequestDto, options?: any) {
        return UserMobilePhoneApiFp(this.configuration).userMobilePhoneUpdate(id, version, mobilePhoneUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} mobilePhone 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserMobilePhoneApi
     */
    public userMobilePhoneValidate(mobilePhone: string, version: string, options?: any) {
        return UserMobilePhoneApiFp(this.configuration).userMobilePhoneValidate(mobilePhone, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserPasswordApi - axios parameter creator
 * @export
 */
export const UserPasswordApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordGetPasswordResetRequest: async (key: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling userPasswordGetPasswordResetRequest.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userPasswordGetPasswordResetRequest.');
            }
            const localVarPath = `/api/v{version}/users/{key}/passwordResetRequest`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordRequestReset: async (userName: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new RequiredError('userName','Required parameter userName was null or undefined when calling userPasswordRequestReset.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userPasswordRequestReset.');
            }
            const localVarPath = `/api/v{version}/users/{userName}/password/sendResetEmail`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateRequestDto} passwordUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUpdate: async (id: string, version: string, passwordUpdateRequestDto: PasswordUpdateRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userPasswordUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userPasswordUpdate.');
            }
            // verify required parameter 'passwordUpdateRequestDto' is not null or undefined
            if (passwordUpdateRequestDto === null || passwordUpdateRequestDto === undefined) {
                throw new RequiredError('passwordUpdateRequestDto','Required parameter passwordUpdateRequestDto was null or undefined when calling userPasswordUpdate.');
            }
            const localVarPath = `/api/v{version}/users/{id}/password`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordUpdateRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordUpdateRequestDto !== undefined ? passwordUpdateRequestDto : {}) : (passwordUpdateRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUpdateBySecurityQuestions: async (id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userPasswordUpdateBySecurityQuestions.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userPasswordUpdateBySecurityQuestions.');
            }
            // verify required parameter 'passwordUpdateBySecurityQuestionRequestDto' is not null or undefined
            if (passwordUpdateBySecurityQuestionRequestDto === null || passwordUpdateBySecurityQuestionRequestDto === undefined) {
                throw new RequiredError('passwordUpdateBySecurityQuestionRequestDto','Required parameter passwordUpdateBySecurityQuestionRequestDto was null or undefined when calling userPasswordUpdateBySecurityQuestions.');
            }
            const localVarPath = `/api/v{version}/users/{id}/password/reset`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof passwordUpdateBySecurityQuestionRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(passwordUpdateBySecurityQuestionRequestDto !== undefined ? passwordUpdateBySecurityQuestionRequestDto : {}) : (passwordUpdateBySecurityQuestionRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPasswordApi - functional programming interface
 * @export
 */
export const UserPasswordApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPasswordGetPasswordResetRequest(key: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndependentAgentProfileDto>> {
            const localVarAxiosArgs = await UserPasswordApiAxiosParamCreator(configuration).userPasswordGetPasswordResetRequest(key, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPasswordRequestReset(userName: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserPasswordApiAxiosParamCreator(configuration).userPasswordRequestReset(userName, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateRequestDto} passwordUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPasswordUpdate(id: string, version: string, passwordUpdateRequestDto: PasswordUpdateRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserPasswordApiAxiosParamCreator(configuration).userPasswordUpdate(id, version, passwordUpdateRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userPasswordUpdateBySecurityQuestions(id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserPasswordApiAxiosParamCreator(configuration).userPasswordUpdateBySecurityQuestions(id, version, passwordUpdateBySecurityQuestionRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserPasswordApi - factory interface
 * @export
 */
export const UserPasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} key 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordGetPasswordResetRequest(key: string, version: string, options?: any): AxiosPromise<IndependentAgentProfileDto> {
            return UserPasswordApiFp(configuration).userPasswordGetPasswordResetRequest(key, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userName 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordRequestReset(userName: string, version: string, options?: any): AxiosPromise<void> {
            return UserPasswordApiFp(configuration).userPasswordRequestReset(userName, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateRequestDto} passwordUpdateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUpdate(id: string, version: string, passwordUpdateRequestDto: PasswordUpdateRequestDto, options?: any): AxiosPromise<void> {
            return UserPasswordApiFp(configuration).userPasswordUpdate(id, version, passwordUpdateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userPasswordUpdateBySecurityQuestions(id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options?: any): AxiosPromise<void> {
            return UserPasswordApiFp(configuration).userPasswordUpdateBySecurityQuestions(id, version, passwordUpdateBySecurityQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPasswordApi - object-oriented interface
 * @export
 * @class UserPasswordApi
 * @extends {BaseAPI}
 */
export class UserPasswordApi extends BaseAPI {
    /**
     * 
     * @param {string} key 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPasswordApi
     */
    public userPasswordGetPasswordResetRequest(key: string, version: string, options?: any) {
        return UserPasswordApiFp(this.configuration).userPasswordGetPasswordResetRequest(key, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userName 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPasswordApi
     */
    public userPasswordRequestReset(userName: string, version: string, options?: any) {
        return UserPasswordApiFp(this.configuration).userPasswordRequestReset(userName, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {PasswordUpdateRequestDto} passwordUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPasswordApi
     */
    public userPasswordUpdate(id: string, version: string, passwordUpdateRequestDto: PasswordUpdateRequestDto, options?: any) {
        return UserPasswordApiFp(this.configuration).userPasswordUpdate(id, version, passwordUpdateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {PasswordUpdateBySecurityQuestionRequestDto} passwordUpdateBySecurityQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPasswordApi
     */
    public userPasswordUpdateBySecurityQuestions(id: string, version: string, passwordUpdateBySecurityQuestionRequestDto: PasswordUpdateBySecurityQuestionRequestDto, options?: any) {
        return UserPasswordApiFp(this.configuration).userPasswordUpdateBySecurityQuestions(id, version, passwordUpdateBySecurityQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserQuestionsApi - axios parameter creator
 * @export
 */
export const UserQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userQuestionsGet: async (version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userQuestionsGet.');
            }
            const localVarPath = `/api/v{version}/users/questions`
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UpdateSecurityQuestionsRequestDto} updateSecurityQuestionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userQuestionsUpdate: async (id: string, version: string, updateSecurityQuestionsRequestDto: UpdateSecurityQuestionsRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userQuestionsUpdate.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userQuestionsUpdate.');
            }
            // verify required parameter 'updateSecurityQuestionsRequestDto' is not null or undefined
            if (updateSecurityQuestionsRequestDto === null || updateSecurityQuestionsRequestDto === undefined) {
                throw new RequiredError('updateSecurityQuestionsRequestDto','Required parameter updateSecurityQuestionsRequestDto was null or undefined when calling userQuestionsUpdate.');
            }
            const localVarPath = `/api/v{version}/users/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof updateSecurityQuestionsRequestDto !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateSecurityQuestionsRequestDto !== undefined ? updateSecurityQuestionsRequestDto : {}) : (updateSecurityQuestionsRequestDto || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserQuestionsApi - functional programming interface
 * @export
 */
export const UserQuestionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userQuestionsGet(version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdentityQuestion>>> {
            const localVarAxiosArgs = await UserQuestionsApiAxiosParamCreator(configuration).userQuestionsGet(version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UpdateSecurityQuestionsRequestDto} updateSecurityQuestionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userQuestionsUpdate(id: string, version: string, updateSecurityQuestionsRequestDto: UpdateSecurityQuestionsRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserQuestionsApiAxiosParamCreator(configuration).userQuestionsUpdate(id, version, updateSecurityQuestionsRequestDto, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserQuestionsApi - factory interface
 * @export
 */
export const UserQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userQuestionsGet(version: string, options?: any): AxiosPromise<Array<IdentityQuestion>> {
            return UserQuestionsApiFp(configuration).userQuestionsGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} version 
         * @param {UpdateSecurityQuestionsRequestDto} updateSecurityQuestionsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userQuestionsUpdate(id: string, version: string, updateSecurityQuestionsRequestDto: UpdateSecurityQuestionsRequestDto, options?: any): AxiosPromise<void> {
            return UserQuestionsApiFp(configuration).userQuestionsUpdate(id, version, updateSecurityQuestionsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserQuestionsApi - object-oriented interface
 * @export
 * @class UserQuestionsApi
 * @extends {BaseAPI}
 */
export class UserQuestionsApi extends BaseAPI {
    /**
     * 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserQuestionsApi
     */
    public userQuestionsGet(version: string, options?: any) {
        return UserQuestionsApiFp(this.configuration).userQuestionsGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} version 
     * @param {UpdateSecurityQuestionsRequestDto} updateSecurityQuestionsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserQuestionsApi
     */
    public userQuestionsUpdate(id: string, version: string, updateSecurityQuestionsRequestDto: UpdateSecurityQuestionsRequestDto, options?: any) {
        return UserQuestionsApiFp(this.configuration).userQuestionsUpdate(id, version, updateSecurityQuestionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * UserUsernameApi - axios parameter creator
 * @export
 */
export const UserUsernameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsernameRecoverUsername: async (email: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling userUsernameRecoverUsername.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling userUsernameRecoverUsername.');
            }
            const localVarPath = `/api/v{version}/users/usernameRecovery/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserUsernameApi - functional programming interface
 * @export
 */
export const UserUsernameApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userUsernameRecoverUsername(email: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await UserUsernameApiAxiosParamCreator(configuration).userUsernameRecoverUsername(email, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserUsernameApi - factory interface
 * @export
 */
export const UserUsernameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUsernameRecoverUsername(email: string, version: string, options?: any): AxiosPromise<any> {
            return UserUsernameApiFp(configuration).userUsernameRecoverUsername(email, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserUsernameApi - object-oriented interface
 * @export
 * @class UserUsernameApi
 * @extends {BaseAPI}
 */
export class UserUsernameApi extends BaseAPI {
    /**
     * 
     * @param {string} email 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserUsernameApi
     */
    public userUsernameRecoverUsername(email: string, version: string, options?: any) {
        return UserUsernameApiFp(this.configuration).userUsernameRecoverUsername(email, version, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * ValidateApi - axios parameter creator
 * @export
 */
export const ValidateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateValidateIdentifier: async (identifier: string, version: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'identifier' is not null or undefined
            if (identifier === null || identifier === undefined) {
                throw new RequiredError('identifier','Required parameter identifier was null or undefined when calling validateValidateIdentifier.');
            }
            // verify required parameter 'version' is not null or undefined
            if (version === null || version === undefined) {
                throw new RequiredError('version','Required parameter version was null or undefined when calling validateValidateIdentifier.');
            }
            const localVarPath = `/api/v{version}/users/validate/identifier/{identifier}`
                .replace(`{${"identifier"}}`, encodeURIComponent(String(identifier)))
                .replace(`{${"version"}}`, encodeURIComponent(String(version)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValidateApi - functional programming interface
 * @export
 */
export const ValidateApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateValidateIdentifier(identifier: string, version: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await ValidateApiAxiosParamCreator(configuration).validateValidateIdentifier(identifier, version, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ValidateApi - factory interface
 * @export
 */
export const ValidateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} identifier 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateValidateIdentifier(identifier: string, version: string, options?: any): AxiosPromise<void> {
            return ValidateApiFp(configuration).validateValidateIdentifier(identifier, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ValidateApi - object-oriented interface
 * @export
 * @class ValidateApi
 * @extends {BaseAPI}
 */
export class ValidateApi extends BaseAPI {
    /**
     * 
     * @param {string} identifier 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValidateApi
     */
    public validateValidateIdentifier(identifier: string, version: string, options?: any) {
        return ValidateApiFp(this.configuration).validateValidateIdentifier(identifier, version, options).then((request) => request(this.axios, this.basePath));
    }

}


